"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Object = _interopRequireDefault(require("./Object.js"));

var _Collection = _interopRequireDefault(require("./Collection.js"));

var _CollectionEventType = _interopRequireDefault(require("./CollectionEventType.js"));

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _Layer = _interopRequireDefault(require("./layer/Layer.js"));

var _Group = _interopRequireWildcard(require("./layer/Group.js"));

var _MapBrowserEvent = _interopRequireDefault(require("./MapBrowserEvent.js"));

var _MapBrowserEventHandler = _interopRequireDefault(require("./MapBrowserEventHandler.js"));

var _MapBrowserEventType = _interopRequireDefault(require("./MapBrowserEventType.js"));

var _MapEvent = _interopRequireDefault(require("./MapEvent.js"));

var _MapEventType = _interopRequireDefault(require("./MapEventType.js"));

var _MapProperty = _interopRequireDefault(require("./MapProperty.js"));

var _ObjectEventType = _interopRequireDefault(require("./ObjectEventType.js"));

var _EventType2 = _interopRequireDefault(require("./pointer/EventType.js"));

var _EventType3 = _interopRequireDefault(require("./render/EventType.js"));

var _TileQueue = _interopRequireWildcard(require("./TileQueue.js"));

var _View = _interopRequireDefault(require("./View.js"));

var _ViewHint = _interopRequireDefault(require("./ViewHint.js"));

var _has = require("./has.js");

var _functions = require("./functions.js");

var _transform = require("./transform.js");

var _asserts = require("./asserts.js");

var _extent = require("./extent.js");

var _proj = require("./proj.js");

var _util = require("./util.js");

var _size = require("./size.js");

var _events = require("./events.js");

var _dom = require("./dom.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/PluggableMap
 */


/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {import("rbush").default} declutterTree DeclutterTree.
 * @property {null|import("./extent.js").Extent} extent Extent.
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */

/**
 * @typedef {function(PluggableMap, ?FrameState): any} PostRenderFunction
 */

/**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */

/**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */

/**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} PluggableMapOnSignature
 */

/**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */

/**
 * @param {import("./layer/Base.js").default} layer Layer.
 */
function removeLayerMapProperty(layer) {
  if (layer instanceof _Layer["default"]) {
    layer.setMapInternal(null);
    return;
  }

  if (layer instanceof _Group["default"]) {
    layer.getLayers().forEach(removeLayerMapProperty);
  }
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {PluggableMap} map Map.
 */


function setLayerMapProperty(layer, map) {
  if (layer instanceof _Layer["default"]) {
    layer.setMapInternal(map);
    return;
  }

  if (layer instanceof _Group["default"]) {
    var layers = layer.getLayers().getArray();

    for (var i = 0, ii = layers.length; i < ii; ++i) {
      setLayerMapProperty(layers[i], map);
    }
  }
}
/**
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */


var PluggableMap =
/** @class */
function (_super) {
  __extends(PluggableMap, _super);
  /**
   * @param {MapOptions} options Map options.
   */


  function PluggableMap(options) {
    var _this = _super.call(this) || this;
    /***
     * @type {PluggableMapOnSignature<import("./events").EventsKey>}
     */


    _this.on;
    /***
     * @type {PluggableMapOnSignature<import("./events").EventsKey>}
     */

    _this.once;
    /***
     * @type {PluggableMapOnSignature<void>}
     */

    _this.un;
    var optionsInternal = createOptionsInternal(options);
    /**
     * @private
     * @type {boolean|undefined}
     */

    _this.renderComplete_;
    /**
     * @private
     * @type {boolean}
     */

    _this.loaded_ = true;
    /** @private */

    _this.boundHandleBrowserEvent_ = _this.handleBrowserEvent.bind(_this);
    /**
     * @type {number}
     * @private
     */

    _this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
    /**
     * @private
     * @type {number}
     */

    _this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : _has.DEVICE_PIXEL_RATIO;
    /**
     * @private
     * @type {*}
     */

    _this.postRenderTimeoutHandle_;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.animationDelayKey_;
    /**
     * @private
     */

    _this.animationDelay_ =
    /** @this {PluggableMap} */
    function () {
      this.animationDelayKey_ = undefined;
      this.renderFrame_(Date.now());
    }.bind(_this);
    /**
     * @private
     * @type {import("./transform.js").Transform}
     */


    _this.coordinateToPixelTransform_ = (0, _transform.create)();
    /**
     * @private
     * @type {import("./transform.js").Transform}
     */

    _this.pixelToCoordinateTransform_ = (0, _transform.create)();
    /**
     * @private
     * @type {number}
     */

    _this.frameIndex_ = 0;
    /**
     * @private
     * @type {?FrameState}
     */

    _this.frameState_ = null;
    /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */

    _this.previousExtent_ = null;
    /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */

    _this.viewPropertyListenerKey_ = null;
    /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */

    _this.viewChangeListenerKey_ = null;
    /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */

    _this.layerGroupPropertyListenerKeys_ = null;
    /**
     * @private
     * @type {!HTMLElement}
     */

    _this.viewport_ = document.createElement('div');
    _this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
    _this.viewport_.style.position = 'relative';
    _this.viewport_.style.overflow = 'hidden';
    _this.viewport_.style.width = '100%';
    _this.viewport_.style.height = '100%';
    /**
     * @private
     * @type {!HTMLElement}
     */

    _this.overlayContainer_ = document.createElement('div');
    _this.overlayContainer_.style.position = 'absolute';
    _this.overlayContainer_.style.zIndex = '0';
    _this.overlayContainer_.style.width = '100%';
    _this.overlayContainer_.style.height = '100%';
    _this.overlayContainer_.style.pointerEvents = 'none';
    _this.overlayContainer_.className = 'ol-overlaycontainer';

    _this.viewport_.appendChild(_this.overlayContainer_);
    /**
     * @private
     * @type {!HTMLElement}
     */


    _this.overlayContainerStopEvent_ = document.createElement('div');
    _this.overlayContainerStopEvent_.style.position = 'absolute';
    _this.overlayContainerStopEvent_.style.zIndex = '0';
    _this.overlayContainerStopEvent_.style.width = '100%';
    _this.overlayContainerStopEvent_.style.height = '100%';
    _this.overlayContainerStopEvent_.style.pointerEvents = 'none';
    _this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';

    _this.viewport_.appendChild(_this.overlayContainerStopEvent_);
    /**
     * @private
     * @type {MapBrowserEventHandler}
     */


    _this.mapBrowserEventHandler_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.moveTolerance_ = options.moveTolerance;
    /**
     * @private
     * @type {HTMLElement|Document}
     */

    _this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
    /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */

    _this.targetChangeHandlerKeys_ = null;
    /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */

    _this.controls = optionsInternal.controls || new _Collection["default"]();
    /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */

    _this.interactions = optionsInternal.interactions || new _Collection["default"]();
    /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */

    _this.overlays_ = optionsInternal.overlays;
    /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */

    _this.overlayIdIndex_ = {};
    /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */

    _this.renderer_ = null;
    /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */

    _this.postRenderFunctions_ = [];
    /**
     * @private
     * @type {TileQueue}
     */

    _this.tileQueue_ = new _TileQueue["default"](_this.getTilePriority.bind(_this), _this.handleTileChange_.bind(_this));

    _this.addChangeListener(_MapProperty["default"].LAYERGROUP, _this.handleLayerGroupChanged_);

    _this.addChangeListener(_MapProperty["default"].VIEW, _this.handleViewChanged_);

    _this.addChangeListener(_MapProperty["default"].SIZE, _this.handleSizeChanged_);

    _this.addChangeListener(_MapProperty["default"].TARGET, _this.handleTargetChanged_); // setProperties will trigger the rendering of the map if the map
    // is "defined" already.


    _this.setProperties(optionsInternal.values);

    var map = _this;

    if (options.view && !(options.view instanceof _View["default"])) {
      options.view.then(function (viewOptions) {
        map.setView(new _View["default"](viewOptions));
      });
    }

    _this.controls.addEventListener(_CollectionEventType["default"].ADD,
    /**
     * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
     */
    function (event) {
      event.element.setMap(this);
    }.bind(_this));

    _this.controls.addEventListener(_CollectionEventType["default"].REMOVE,
    /**
     * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
     */
    function (event) {
      event.element.setMap(null);
    }.bind(_this));

    _this.interactions.addEventListener(_CollectionEventType["default"].ADD,
    /**
     * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
     */
    function (event) {
      event.element.setMap(this);
    }.bind(_this));

    _this.interactions.addEventListener(_CollectionEventType["default"].REMOVE,
    /**
     * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
     */
    function (event) {
      event.element.setMap(null);
    }.bind(_this));

    _this.overlays_.addEventListener(_CollectionEventType["default"].ADD,
    /**
     * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
     */
    function (event) {
      this.addOverlayInternal_(
      /** @type {import("./Overlay.js").default} */
      event.element);
    }.bind(_this));

    _this.overlays_.addEventListener(_CollectionEventType["default"].REMOVE,
    /**
     * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
     */
    function (event) {
      var overlay =
      /** @type {import("./Overlay.js").default} */
      event.element;
      var id = overlay.getId();

      if (id !== undefined) {
        delete this.overlayIdIndex_[id.toString()];
      }

      event.element.setMap(null);
    }.bind(_this));

    _this.controls.forEach(
    /**
     * @param {import("./control/Control.js").default} control Control.
     * @this {PluggableMap}
     */
    function (control) {
      control.setMap(this);
    }.bind(_this));

    _this.interactions.forEach(
    /**
     * @param {import("./interaction/Interaction.js").default} interaction Interaction.
     * @this {PluggableMap}
     */
    function (interaction) {
      interaction.setMap(this);
    }.bind(_this));

    _this.overlays_.forEach(_this.addOverlayInternal_.bind(_this));

    return _this;
  }
  /**
   * @abstract
   * @return {import("./renderer/Map.js").default} The map renderer
   */


  PluggableMap.prototype.createRenderer = function () {
    throw new Error('Use a map type that has a createRenderer method');
  };
  /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */


  PluggableMap.prototype.addControl = function (control) {
    this.getControls().push(control);
  };
  /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteraction()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */


  PluggableMap.prototype.addInteraction = function (interaction) {
    this.getInteractions().push(interaction);
  };
  /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */


  PluggableMap.prototype.addLayer = function (layer) {
    var layers = this.getLayerGroup().getLayers();
    layers.push(layer);
  };
  /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */


  PluggableMap.prototype.handleLayerAdd_ = function (event) {
    setLayerMapProperty(event.layer, this);
  };
  /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */


  PluggableMap.prototype.addOverlay = function (overlay) {
    this.getOverlays().push(overlay);
  };
  /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */


  PluggableMap.prototype.addOverlayInternal_ = function (overlay) {
    var id = overlay.getId();

    if (id !== undefined) {
      this.overlayIdIndex_[id.toString()] = overlay;
    }

    overlay.setMap(this);
  };
  /**
   *
   * Clean up.
   */


  PluggableMap.prototype.disposeInternal = function () {
    this.setTarget(null);

    _super.prototype.disposeInternal.call(this);
  };
  /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `opt_options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [opt_options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */


  PluggableMap.prototype.forEachFeatureAtPixel = function (pixel, callback, opt_options) {
    if (!this.frameState_ || !this.renderer_) {
      return;
    }

    var coordinate = this.getCoordinateFromPixelInternal(pixel);
    opt_options = opt_options !== undefined ? opt_options : {};
    var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
    var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : _functions.TRUE;
    var checkWrapped = opt_options.checkWrapped !== false;
    return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
  };
  /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [opt_options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */


  PluggableMap.prototype.getFeaturesAtPixel = function (pixel, opt_options) {
    var features = [];
    this.forEachFeatureAtPixel(pixel, function (feature) {
      features.push(feature);
    }, opt_options);
    return features;
  };
  /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */


  PluggableMap.prototype.getAllLayers = function () {
    var layers = [];

    function addLayersFrom(layerGroup) {
      layerGroup.forEach(function (layer) {
        if (layer instanceof _Group["default"]) {
          addLayersFrom(layer.getLayers());
        } else {
          layers.push(layer);
        }
      });
    }

    addLayersFrom(this.getLayers());
    return layers;
  };
  /**
   * Please the `layer.getData()` method for {@link module:ol/layer/Tile~TileLayer#getData tile layers} or
   * {@link module:ol/layer/Image~ImageLayer#getData image layers} instead of using this method.
   *
   * Detect layers that have a color value at a pixel on the viewport, and
   * execute a callback with each matching layer. Layers included in the
   * detection can be configured through `opt_layerFilter`.
   *
   * Note: In maps with more than one layer, this method will typically return pixel data
   * representing the composed image of all layers visible at the given pixel – because layers
   * will generally share the same rendering context.  To force layers to render separately, and
   * to get pixel data representing only one layer at a time, you can assign each layer a unique
   * `className` in its constructor.
   *
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(this: S, import("./layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback
   *     Layer callback. This callback will receive two arguments: first is the
   *     {@link module:ol/layer/Layer~Layer layer}, second argument is an array representing
   *     [R, G, B, A] pixel values (0 - 255) and will be `null` for layer types
   *     that do not currently support this argument. To stop detection, callback
   *     functions can return a truthy value.
   * @param {AtPixelOptions} [opt_options] Configuration options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template S,T
   * @api
   * @deprecated
   */


  PluggableMap.prototype.forEachLayerAtPixel = function (pixel, callback, opt_options) {
    if (!this.frameState_ || !this.renderer_) {
      return;
    }

    var options = opt_options || {};
    var hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
    var layerFilter = options.layerFilter || _functions.TRUE;
    return this.renderer_.forEachLayerAtPixel(pixel, this.frameState_, hitTolerance, callback, layerFilter);
  };
  /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through `opt_layerFilter`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [opt_options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */


  PluggableMap.prototype.hasFeatureAtPixel = function (pixel, opt_options) {
    if (!this.frameState_ || !this.renderer_) {
      return false;
    }

    var coordinate = this.getCoordinateFromPixelInternal(pixel);
    opt_options = opt_options !== undefined ? opt_options : {};
    var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : _functions.TRUE;
    var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
    var checkWrapped = opt_options.checkWrapped !== false;
    return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
  };
  /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */


  PluggableMap.prototype.getEventCoordinate = function (event) {
    return this.getCoordinateFromPixel(this.getEventPixel(event));
  };
  /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */


  PluggableMap.prototype.getEventCoordinateInternal = function (event) {
    return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
  };
  /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */


  PluggableMap.prototype.getEventPixel = function (event) {
    var viewportPosition = this.viewport_.getBoundingClientRect();
    var eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
    'changedTouches' in event ?
    /** @type {TouchEvent} */
    event.changedTouches[0] :
    /** @type {MouseEvent} */
    event;
    return [eventPosition.clientX - viewportPosition.left, eventPosition.clientY - viewportPosition.top];
  };
  /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */


  PluggableMap.prototype.getTarget = function () {
    return (
      /** @type {HTMLElement|string|undefined} */
      this.get(_MapProperty["default"].TARGET)
    );
  };
  /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */


  PluggableMap.prototype.getTargetElement = function () {
    var target = this.getTarget();

    if (target !== undefined) {
      return typeof target === 'string' ? document.getElementById(target) : target;
    } else {
      return null;
    }
  };
  /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */


  PluggableMap.prototype.getCoordinateFromPixel = function (pixel) {
    return (0, _proj.toUserCoordinate)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
  };
  /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */


  PluggableMap.prototype.getCoordinateFromPixelInternal = function (pixel) {
    var frameState = this.frameState_;

    if (!frameState) {
      return null;
    } else {
      return (0, _transform.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
  };
  /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */


  PluggableMap.prototype.getControls = function () {
    return this.controls;
  };
  /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */


  PluggableMap.prototype.getOverlays = function () {
    return this.overlays_;
  };
  /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default} Overlay.
   * @api
   */


  PluggableMap.prototype.getOverlayById = function (id) {
    var overlay = this.overlayIdIndex_[id.toString()];
    return overlay !== undefined ? overlay : null;
  };
  /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */


  PluggableMap.prototype.getInteractions = function () {
    return this.interactions;
  };
  /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */


  PluggableMap.prototype.getLayerGroup = function () {
    return (
      /** @type {LayerGroup} */
      this.get(_MapProperty["default"].LAYERGROUP)
    );
  };
  /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */


  PluggableMap.prototype.setLayers = function (layers) {
    var group = this.getLayerGroup();

    if (layers instanceof _Collection["default"]) {
      group.setLayers(layers);
      return;
    }

    var collection = group.getLayers();
    collection.clear();
    collection.extend(layers);
  };
  /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */


  PluggableMap.prototype.getLayers = function () {
    var layers = this.getLayerGroup().getLayers();
    return layers;
  };
  /**
   * @return {boolean} Layers have sources that are still loading.
   */


  PluggableMap.prototype.getLoadingOrNotReady = function () {
    var layerStatesArray = this.getLayerGroup().getLayerStatesArray();

    for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
      var state = layerStatesArray[i];

      if (!state.visible) {
        continue;
      }

      var renderer = state.layer.getRenderer();

      if (renderer && !renderer.ready) {
        return true;
      }

      var source =
      /** @type {import("./layer/Layer.js").default} */
      state.layer.getSource();

      if (source && source.loading) {
        return true;
      }
    }

    return false;
  };
  /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */


  PluggableMap.prototype.getPixelFromCoordinate = function (coordinate) {
    var viewCoordinate = (0, _proj.fromUserCoordinate)(coordinate, this.getView().getProjection());
    return this.getPixelFromCoordinateInternal(viewCoordinate);
  };
  /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */


  PluggableMap.prototype.getPixelFromCoordinateInternal = function (coordinate) {
    var frameState = this.frameState_;

    if (!frameState) {
      return null;
    } else {
      return (0, _transform.apply)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
  };
  /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */


  PluggableMap.prototype.getRenderer = function () {
    return this.renderer_;
  };
  /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */


  PluggableMap.prototype.getSize = function () {
    return (
      /** @type {import("./size.js").Size|undefined} */
      this.get(_MapProperty["default"].SIZE)
    );
  };
  /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */


  PluggableMap.prototype.getView = function () {
    return (
      /** @type {View} */
      this.get(_MapProperty["default"].VIEW)
    );
  };
  /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */


  PluggableMap.prototype.getViewport = function () {
    return this.viewport_;
  };
  /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */


  PluggableMap.prototype.getOverlayContainer = function () {
    return this.overlayContainer_;
  };
  /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */


  PluggableMap.prototype.getOverlayContainerStopEvent = function () {
    return this.overlayContainerStopEvent_;
  };
  /**
   * @return {!Document} The document where the map is displayed.
   */


  PluggableMap.prototype.getOwnerDocument = function () {
    var targetElement = this.getTargetElement();
    return targetElement ? targetElement.ownerDocument : document;
  };
  /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */


  PluggableMap.prototype.getTilePriority = function (tile, tileSourceKey, tileCenter, tileResolution) {
    return (0, _TileQueue.getTilePriority)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
  };
  /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [opt_type] Type.
   */


  PluggableMap.prototype.handleBrowserEvent = function (browserEvent, opt_type) {
    var type = opt_type || browserEvent.type;
    var mapBrowserEvent = new _MapBrowserEvent["default"](type, this, browserEvent);
    this.handleMapBrowserEvent(mapBrowserEvent);
  };
  /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */


  PluggableMap.prototype.handleMapBrowserEvent = function (mapBrowserEvent) {
    if (!this.frameState_) {
      // With no view defined, we cannot translate pixels into geographical
      // coordinates so interactions cannot be used.
      return;
    }

    var originalEvent =
    /** @type {PointerEvent} */
    mapBrowserEvent.originalEvent;
    var eventType = originalEvent.type;

    if (eventType === _EventType2["default"].POINTERDOWN || eventType === _EventType["default"].WHEEL || eventType === _EventType["default"].KEYDOWN) {
      var doc = this.getOwnerDocument();
      var rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
      var target =
      /** @type {Node} */
      originalEvent.target;

      if ( // Abort if the target is a child of the container for elements whose events are not meant
      // to be handled by map interactions.
      this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
      // It's possible for the target to no longer be in the page if it has been removed in an
      // event listener, this might happen in a Control that recreates it's content based on
      // user interaction either manually or via a render in something like https://reactjs.org/
      !(rootNode === doc ? doc.documentElement : rootNode).contains(target)) {
        return;
      }
    }

    mapBrowserEvent.frameState = this.frameState_;

    if (this.dispatchEvent(mapBrowserEvent) !== false) {
      var interactionsArray = this.getInteractions().getArray().slice();

      for (var i = interactionsArray.length - 1; i >= 0; i--) {
        var interaction = interactionsArray[i];

        if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) {
          continue;
        }

        var cont = interaction.handleEvent(mapBrowserEvent);

        if (!cont || mapBrowserEvent.propagationStopped) {
          break;
        }
      }
    }
  };
  /**
   * @protected
   */


  PluggableMap.prototype.handlePostRender = function () {
    var frameState = this.frameState_; // Manage the tile queue
    // Image loads are expensive and a limited resource, so try to use them
    // efficiently:
    // * When the view is static we allow a large number of parallel tile loads
    //   to complete the frame as quickly as possible.
    // * When animating or interacting, image loads can cause janks, so we reduce
    //   the maximum number of loads per frame and limit the number of parallel
    //   tile loads to remain reactive to view changes and to reduce the chance of
    //   loading tiles that will quickly disappear from view.

    var tileQueue = this.tileQueue_;

    if (!tileQueue.isEmpty()) {
      var maxTotalLoading = this.maxTilesLoading_;
      var maxNewLoads = maxTotalLoading;

      if (frameState) {
        var hints = frameState.viewHints;

        if (hints[_ViewHint["default"].ANIMATING] || hints[_ViewHint["default"].INTERACTING]) {
          var lowOnFrameBudget = Date.now() - frameState.time > 8;
          maxTotalLoading = lowOnFrameBudget ? 0 : 8;
          maxNewLoads = lowOnFrameBudget ? 0 : 2;
        }
      }

      if (tileQueue.getTilesLoading() < maxTotalLoading) {
        tileQueue.reprioritize(); // FIXME only call if view has changed

        tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
      }
    }

    if (frameState && this.renderer_ && !frameState.animate) {
      if (this.renderComplete_ === true) {
        if (this.hasListener(_EventType3["default"].RENDERCOMPLETE)) {
          this.renderer_.dispatchRenderEvent(_EventType3["default"].RENDERCOMPLETE, frameState);
        }

        if (this.loaded_ === false) {
          this.loaded_ = true;
          this.dispatchEvent(new _MapEvent["default"](_MapEventType["default"].LOADEND, this, frameState));
        }
      } else if (this.loaded_ === true) {
        this.loaded_ = false;
        this.dispatchEvent(new _MapEvent["default"](_MapEventType["default"].LOADSTART, this, frameState));
      }
    }

    var postRenderFunctions = this.postRenderFunctions_;

    for (var i = 0, ii = postRenderFunctions.length; i < ii; ++i) {
      postRenderFunctions[i](this, frameState);
    }

    postRenderFunctions.length = 0;
  };
  /**
   * @private
   */


  PluggableMap.prototype.handleSizeChanged_ = function () {
    if (this.getView() && !this.getView().getAnimating()) {
      this.getView().resolveConstraints(0);
    }

    this.render();
  };
  /**
   * @private
   */


  PluggableMap.prototype.handleTargetChanged_ = function () {
    if (this.mapBrowserEventHandler_) {
      for (var i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i) {
        (0, _events.unlistenByKey)(this.targetChangeHandlerKeys_[i]);
      }

      this.targetChangeHandlerKeys_ = null;
      this.viewport_.removeEventListener(_EventType["default"].CONTEXTMENU, this.boundHandleBrowserEvent_);
      this.viewport_.removeEventListener(_EventType["default"].WHEEL, this.boundHandleBrowserEvent_);
      this.mapBrowserEventHandler_.dispose();
      this.mapBrowserEventHandler_ = null;
      (0, _dom.removeNode)(this.viewport_);
    } // target may be undefined, null, a string or an Element.
    // If it's a string we convert it to an Element before proceeding.
    // If it's not now an Element we remove the viewport from the DOM.
    // If it's an Element we append the viewport element to it.


    var targetElement = this.getTargetElement();

    if (!targetElement) {
      if (this.renderer_) {
        clearTimeout(this.postRenderTimeoutHandle_);
        this.postRenderTimeoutHandle_ = undefined;
        this.postRenderFunctions_.length = 0;
        this.renderer_.dispose();
        this.renderer_ = null;
      }

      if (this.animationDelayKey_) {
        cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelayKey_ = undefined;
      }
    } else {
      targetElement.appendChild(this.viewport_);

      if (!this.renderer_) {
        this.renderer_ = this.createRenderer();
      }

      this.mapBrowserEventHandler_ = new _MapBrowserEventHandler["default"](this, this.moveTolerance_);

      for (var key in _MapBrowserEventType["default"]) {
        this.mapBrowserEventHandler_.addEventListener(_MapBrowserEventType["default"][key], this.handleMapBrowserEvent.bind(this));
      }

      this.viewport_.addEventListener(_EventType["default"].CONTEXTMENU, this.boundHandleBrowserEvent_, false);
      this.viewport_.addEventListener(_EventType["default"].WHEEL, this.boundHandleBrowserEvent_, _has.PASSIVE_EVENT_LISTENERS ? {
        passive: false
      } : false);
      var defaultView = this.getOwnerDocument().defaultView;
      var keyboardEventTarget = !this.keyboardEventTarget_ ? targetElement : this.keyboardEventTarget_;
      this.targetChangeHandlerKeys_ = [(0, _events.listen)(keyboardEventTarget, _EventType["default"].KEYDOWN, this.handleBrowserEvent, this), (0, _events.listen)(keyboardEventTarget, _EventType["default"].KEYPRESS, this.handleBrowserEvent, this), (0, _events.listen)(defaultView, _EventType["default"].RESIZE, this.updateSize, this)];
    }

    this.updateSize(); // updateSize calls setSize, so no need to call this.render
    // ourselves here.
  };
  /**
   * @private
   */


  PluggableMap.prototype.handleTileChange_ = function () {
    this.render();
  };
  /**
   * @private
   */


  PluggableMap.prototype.handleViewPropertyChanged_ = function () {
    this.render();
  };
  /**
   * @private
   */


  PluggableMap.prototype.handleViewChanged_ = function () {
    if (this.viewPropertyListenerKey_) {
      (0, _events.unlistenByKey)(this.viewPropertyListenerKey_);
      this.viewPropertyListenerKey_ = null;
    }

    if (this.viewChangeListenerKey_) {
      (0, _events.unlistenByKey)(this.viewChangeListenerKey_);
      this.viewChangeListenerKey_ = null;
    }

    var view = this.getView();

    if (view) {
      this.updateViewportSize_();
      this.viewPropertyListenerKey_ = (0, _events.listen)(view, _ObjectEventType["default"].PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
      this.viewChangeListenerKey_ = (0, _events.listen)(view, _EventType["default"].CHANGE, this.handleViewPropertyChanged_, this);
      view.resolveConstraints(0);
    }

    this.render();
  };
  /**
   * @private
   */


  PluggableMap.prototype.handleLayerGroupChanged_ = function () {
    if (this.layerGroupPropertyListenerKeys_) {
      this.layerGroupPropertyListenerKeys_.forEach(_events.unlistenByKey);
      this.layerGroupPropertyListenerKeys_ = null;
    }

    var layerGroup = this.getLayerGroup();

    if (layerGroup) {
      this.handleLayerAdd_(new _Group.GroupEvent('addlayer', layerGroup));
      this.layerGroupPropertyListenerKeys_ = [(0, _events.listen)(layerGroup, _ObjectEventType["default"].PROPERTYCHANGE, this.render, this), (0, _events.listen)(layerGroup, _EventType["default"].CHANGE, this.render, this), (0, _events.listen)(layerGroup, 'addlayer', this.handleLayerAdd_, this), (0, _events.listen)(layerGroup, 'removelayer', this.handleLayerRemove_, this)];
    }

    this.render();
  };
  /**
   * @return {boolean} Is rendered.
   */


  PluggableMap.prototype.isRendered = function () {
    return !!this.frameState_;
  };
  /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */


  PluggableMap.prototype.renderSync = function () {
    if (this.animationDelayKey_) {
      cancelAnimationFrame(this.animationDelayKey_);
    }

    this.animationDelay_();
  };
  /**
   * Redraws all text after new fonts have loaded
   */


  PluggableMap.prototype.redrawText = function () {
    var layerStates = this.getLayerGroup().getLayerStatesArray();

    for (var i = 0, ii = layerStates.length; i < ii; ++i) {
      var layer = layerStates[i].layer;

      if (layer.hasRenderer()) {
        layer.getRenderer().handleFontsChanged();
      }
    }
  };
  /**
   * Request a map rendering (at the next animation frame).
   * @api
   */


  PluggableMap.prototype.render = function () {
    if (this.renderer_ && this.animationDelayKey_ === undefined) {
      this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
  };
  /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */


  PluggableMap.prototype.removeControl = function (control) {
    return this.getControls().remove(control);
  };
  /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */


  PluggableMap.prototype.removeInteraction = function (interaction) {
    return this.getInteractions().remove(interaction);
  };
  /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */


  PluggableMap.prototype.removeLayer = function (layer) {
    var layers = this.getLayerGroup().getLayers();
    return layers.remove(layer);
  };
  /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */


  PluggableMap.prototype.handleLayerRemove_ = function (event) {
    removeLayerMapProperty(event.layer);
  };
  /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */


  PluggableMap.prototype.removeOverlay = function (overlay) {
    return this.getOverlays().remove(overlay);
  };
  /**
   * @param {number} time Time.
   * @private
   */


  PluggableMap.prototype.renderFrame_ = function (time) {
    var _this = this;

    var size = this.getSize();
    var view = this.getView();
    var previousFrameState = this.frameState_;
    /** @type {?FrameState} */

    var frameState = null;

    if (size !== undefined && (0, _size.hasArea)(size) && view && view.isDef()) {
      var viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
      var viewState = view.getState();
      frameState = {
        animate: false,
        coordinateToPixelTransform: this.coordinateToPixelTransform_,
        declutterTree: null,
        extent: (0, _extent.getForViewAndSize)(viewState.center, viewState.resolution, viewState.rotation, size),
        index: this.frameIndex_++,
        layerIndex: 0,
        layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
        pixelRatio: this.pixelRatio_,
        pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
        postRenderFunctions: [],
        size: size,
        tileQueue: this.tileQueue_,
        time: time,
        usedTiles: {},
        viewState: viewState,
        viewHints: viewHints,
        wantedTiles: {},
        mapId: (0, _util.getUid)(this),
        renderTargets: {}
      };

      if (viewState.nextCenter && viewState.nextResolution) {
        var rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
        frameState.nextExtent = (0, _extent.getForViewAndSize)(viewState.nextCenter, viewState.nextResolution, rotation, size);
      }
    }

    this.frameState_ = frameState;
    /** @type {import("./renderer/Map.js").default} */

    this.renderer_.renderFrame(frameState);

    if (frameState) {
      if (frameState.animate) {
        this.render();
      }

      Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);

      if (previousFrameState) {
        var moveStart = !this.previousExtent_ || !(0, _extent.isEmpty)(this.previousExtent_) && !(0, _extent.equals)(frameState.extent, this.previousExtent_);

        if (moveStart) {
          this.dispatchEvent(new _MapEvent["default"](_MapEventType["default"].MOVESTART, this, previousFrameState));
          this.previousExtent_ = (0, _extent.createOrUpdateEmpty)(this.previousExtent_);
        }
      }

      var idle = this.previousExtent_ && !frameState.viewHints[_ViewHint["default"].ANIMATING] && !frameState.viewHints[_ViewHint["default"].INTERACTING] && !(0, _extent.equals)(frameState.extent, this.previousExtent_);

      if (idle) {
        this.dispatchEvent(new _MapEvent["default"](_MapEventType["default"].MOVEEND, this, frameState));
        (0, _extent.clone)(frameState.extent, this.previousExtent_);
      }
    }

    this.dispatchEvent(new _MapEvent["default"](_MapEventType["default"].POSTRENDER, this, frameState));
    this.renderComplete_ = this.hasListener(_MapEventType["default"].LOADSTART) || this.hasListener(_MapEventType["default"].LOADEND) || this.hasListener(_EventType3["default"].RENDERCOMPLETE) ? !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady() : undefined;

    if (!this.postRenderTimeoutHandle_) {
      this.postRenderTimeoutHandle_ = setTimeout(function () {
        _this.postRenderTimeoutHandle_ = undefined;

        _this.handlePostRender();
      }, 0);
    }
  };
  /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */


  PluggableMap.prototype.setLayerGroup = function (layerGroup) {
    var oldLayerGroup = this.getLayerGroup();

    if (oldLayerGroup) {
      this.handleLayerRemove_(new _Group.GroupEvent('removelayer', oldLayerGroup));
    }

    this.set(_MapProperty["default"].LAYERGROUP, layerGroup);
  };
  /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */


  PluggableMap.prototype.setSize = function (size) {
    this.set(_MapProperty["default"].SIZE, size);
  };
  /**
   * Set the target element to render this map into.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */


  PluggableMap.prototype.setTarget = function (target) {
    this.set(_MapProperty["default"].TARGET, target);
  };
  /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */


  PluggableMap.prototype.setView = function (view) {
    if (!view || view instanceof _View["default"]) {
      this.set(_MapProperty["default"].VIEW, view);
      return;
    }

    this.set(_MapProperty["default"].VIEW, new _View["default"]());
    var map = this;
    view.then(function (viewOptions) {
      map.setView(new _View["default"](viewOptions));
    });
  };
  /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */


  PluggableMap.prototype.updateSize = function () {
    var targetElement = this.getTargetElement();
    var size = undefined;

    if (targetElement) {
      var computedStyle = getComputedStyle(targetElement);
      var width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
      var height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);

      if (!isNaN(width) && !isNaN(height)) {
        size = [width, height];

        if (!(0, _size.hasArea)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) {
          // eslint-disable-next-line
          console.warn("No map visible because the map container's width or height are 0.");
        }
      }
    }

    this.setSize(size);
    this.updateViewportSize_();
  };
  /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @private
   */


  PluggableMap.prototype.updateViewportSize_ = function () {
    var view = this.getView();

    if (view) {
      var size = undefined;
      var computedStyle = getComputedStyle(this.viewport_);

      if (computedStyle.width && computedStyle.height) {
        size = [parseInt(computedStyle.width, 10), parseInt(computedStyle.height, 10)];
      }

      view.setViewportSize(size);
    }
  };

  return PluggableMap;
}(_Object["default"]);
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */


function createOptionsInternal(options) {
  /**
   * @type {HTMLElement|Document}
   */
  var keyboardEventTarget = null;

  if (options.keyboardEventTarget !== undefined) {
    keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
  }
  /**
   * @type {Object<string, *>}
   */


  var values = {};
  var layerGroup = options.layers && typeof
  /** @type {?} */
  options.layers.getLayers === 'function' ?
  /** @type {LayerGroup} */
  options.layers : new _Group["default"]({
    layers:
    /** @type {Collection} */
    options.layers
  });
  values[_MapProperty["default"].LAYERGROUP] = layerGroup;
  values[_MapProperty["default"].TARGET] = options.target;
  values[_MapProperty["default"].VIEW] = options.view instanceof _View["default"] ? options.view : new _View["default"]();
  var controls;

  if (options.controls !== undefined) {
    if (Array.isArray(options.controls)) {
      controls = new _Collection["default"](options.controls.slice());
    } else {
      (0, _asserts.assert)(typeof
      /** @type {?} */
      options.controls.getArray === 'function', 47); // Expected `controls` to be an array or an `import("./Collection.js").Collection`

      controls =
      /** @type {Collection} */
      options.controls;
    }
  }

  var interactions;

  if (options.interactions !== undefined) {
    if (Array.isArray(options.interactions)) {
      interactions = new _Collection["default"](options.interactions.slice());
    } else {
      (0, _asserts.assert)(typeof
      /** @type {?} */
      options.interactions.getArray === 'function', 48); // Expected `interactions` to be an array or an `import("./Collection.js").Collection`

      interactions =
      /** @type {Collection} */
      options.interactions;
    }
  }

  var overlays;

  if (options.overlays !== undefined) {
    if (Array.isArray(options.overlays)) {
      overlays = new _Collection["default"](options.overlays.slice());
    } else {
      (0, _asserts.assert)(typeof
      /** @type {?} */
      options.overlays.getArray === 'function', 49); // Expected `overlays` to be an array or an `import("./Collection.js").Collection`

      overlays = options.overlays;
    }
  } else {
    overlays = new _Collection["default"]();
  }

  return {
    controls: controls,
    interactions: interactions,
    keyboardEventTarget: keyboardEventTarget,
    overlays: overlays,
    values: values
  };
}

var _default = PluggableMap;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBR0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBSUE7O0FBQ0E7O0FBT0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBdkNBOzs7OztBQXlDQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUEwQkE7Ozs7QUFJQTs7Ozs7Ozs7Ozs7OztBQWFBOzs7Ozs7Ozs7QUFTQTs7OztBQUlBOzs7Ozs7Ozs7Ozs7QUFZQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQXdDQTs7O0FBR0EsU0FBU0Esc0JBQVQsQ0FBZ0NDLEtBQWhDLEVBQXFDO0VBQ25DLElBQUlBLEtBQUssWUFBWUMsaUJBQXJCLEVBQTRCO0lBQzFCRCxLQUFLLENBQUNFLGNBQU4sQ0FBcUIsSUFBckI7SUFDQTtFQUNEOztFQUNELElBQUlGLEtBQUssWUFBWUcsaUJBQXJCLEVBQWlDO0lBQy9CSCxLQUFLLENBQUNJLFNBQU4sR0FBa0JDLE9BQWxCLENBQTBCTixzQkFBMUI7RUFDRDtBQUNGO0FBRUQ7Ozs7OztBQUlBLFNBQVNPLG1CQUFULENBQTZCTixLQUE3QixFQUFvQ08sR0FBcEMsRUFBdUM7RUFDckMsSUFBSVAsS0FBSyxZQUFZQyxpQkFBckIsRUFBNEI7SUFDMUJELEtBQUssQ0FBQ0UsY0FBTixDQUFxQkssR0FBckI7SUFDQTtFQUNEOztFQUNELElBQUlQLEtBQUssWUFBWUcsaUJBQXJCLEVBQWlDO0lBQy9CLElBQU1LLE1BQU0sR0FBR1IsS0FBSyxDQUFDSSxTQUFOLEdBQWtCSyxRQUFsQixFQUFmOztJQUNBLEtBQUssSUFBSUMsQ0FBQyxHQUFHLENBQVIsRUFBV0MsRUFBRSxHQUFHSCxNQUFNLENBQUNJLE1BQTVCLEVBQW9DRixDQUFDLEdBQUdDLEVBQXhDLEVBQTRDLEVBQUVELENBQTlDLEVBQWlEO01BQy9DSixtQkFBbUIsQ0FBQ0UsTUFBTSxDQUFDRSxDQUFELENBQVAsRUFBWUgsR0FBWixDQUFuQjtJQUNEO0VBQ0Y7QUFDRjtBQUVEOzs7Ozs7Ozs7O0FBUUE7QUFBQTtBQUFBO0VBQTJCTTtFQUN6Qjs7Ozs7RUFHQSxzQkFBWUMsT0FBWixFQUFtQjtJQUFuQixZQUNFQyxxQkFBTyxJQURUO0lBR0U7Ozs7O0lBR0FDLEtBQUksQ0FBQ0MsRUFBTDtJQUVBOzs7O0lBR0FELEtBQUksQ0FBQ0UsSUFBTDtJQUVBOzs7O0lBR0FGLEtBQUksQ0FBQ0csRUFBTDtJQUVBLElBQU1DLGVBQWUsR0FBR0MscUJBQXFCLENBQUNQLE9BQUQsQ0FBN0M7SUFFQTs7Ozs7SUFJQUUsS0FBSSxDQUFDTSxlQUFMO0lBRUE7Ozs7O0lBSUFOLEtBQUksQ0FBQ08sT0FBTCxHQUFlLElBQWY7SUFFQTs7SUFDQVAsS0FBSSxDQUFDUSx3QkFBTCxHQUFnQ1IsS0FBSSxDQUFDUyxrQkFBTCxDQUF3QkMsSUFBeEIsQ0FBNkJWLEtBQTdCLENBQWhDO0lBRUE7Ozs7O0lBSUFBLEtBQUksQ0FBQ1csZ0JBQUwsR0FDRWIsT0FBTyxDQUFDYyxlQUFSLEtBQTRCQyxTQUE1QixHQUF3Q2YsT0FBTyxDQUFDYyxlQUFoRCxHQUFrRSxFQURwRTtJQUdBOzs7OztJQUlBWixLQUFJLENBQUNjLFdBQUwsR0FDRWhCLE9BQU8sQ0FBQ2lCLFVBQVIsS0FBdUJGLFNBQXZCLEdBQ0lmLE9BQU8sQ0FBQ2lCLFVBRFosR0FFSUMsdUJBSE47SUFLQTs7Ozs7SUFJQWhCLEtBQUksQ0FBQ2lCLHdCQUFMO0lBRUE7Ozs7O0lBSUFqQixLQUFJLENBQUNrQixrQkFBTDtJQUVBOzs7O0lBR0FsQixLQUFJLENBQUNtQixlQUFMO0lBQXVCO0lBQTRCO01BQ2pELEtBQUtELGtCQUFMLEdBQTBCTCxTQUExQjtNQUNBLEtBQUtPLFlBQUwsQ0FBa0JDLElBQUksQ0FBQ0MsR0FBTCxFQUFsQjtJQUNELENBSGtELENBR2pEWixJQUhpRCxDQUc1Q1YsS0FINEMsQ0FBbkQ7SUFLQTs7Ozs7O0lBSUFBLEtBQUksQ0FBQ3VCLDJCQUFMLEdBQW1DLHdCQUFuQztJQUVBOzs7OztJQUlBdkIsS0FBSSxDQUFDd0IsMkJBQUwsR0FBbUMsd0JBQW5DO0lBRUE7Ozs7O0lBSUF4QixLQUFJLENBQUN5QixXQUFMLEdBQW1CLENBQW5CO0lBRUE7Ozs7O0lBSUF6QixLQUFJLENBQUMwQixXQUFMLEdBQW1CLElBQW5CO0lBRUE7Ozs7OztJQUtBMUIsS0FBSSxDQUFDMkIsZUFBTCxHQUF1QixJQUF2QjtJQUVBOzs7OztJQUlBM0IsS0FBSSxDQUFDNEIsd0JBQUwsR0FBZ0MsSUFBaEM7SUFFQTs7Ozs7SUFJQTVCLEtBQUksQ0FBQzZCLHNCQUFMLEdBQThCLElBQTlCO0lBRUE7Ozs7O0lBSUE3QixLQUFJLENBQUM4QiwrQkFBTCxHQUF1QyxJQUF2QztJQUVBOzs7OztJQUlBOUIsS0FBSSxDQUFDK0IsU0FBTCxHQUFpQkMsUUFBUSxDQUFDQyxhQUFULENBQXVCLEtBQXZCLENBQWpCO0lBQ0FqQyxLQUFJLENBQUMrQixTQUFMLENBQWVHLFNBQWYsR0FDRSxpQkFBaUIsa0JBQWtCQyxNQUFsQixHQUEyQixXQUEzQixHQUF5QyxFQUExRCxDQURGO0lBRUFuQyxLQUFJLENBQUMrQixTQUFMLENBQWVLLEtBQWYsQ0FBcUJDLFFBQXJCLEdBQWdDLFVBQWhDO0lBQ0FyQyxLQUFJLENBQUMrQixTQUFMLENBQWVLLEtBQWYsQ0FBcUJFLFFBQXJCLEdBQWdDLFFBQWhDO0lBQ0F0QyxLQUFJLENBQUMrQixTQUFMLENBQWVLLEtBQWYsQ0FBcUJHLEtBQXJCLEdBQTZCLE1BQTdCO0lBQ0F2QyxLQUFJLENBQUMrQixTQUFMLENBQWVLLEtBQWYsQ0FBcUJJLE1BQXJCLEdBQThCLE1BQTlCO0lBRUE7Ozs7O0lBSUF4QyxLQUFJLENBQUN5QyxpQkFBTCxHQUF5QlQsUUFBUSxDQUFDQyxhQUFULENBQXVCLEtBQXZCLENBQXpCO0lBQ0FqQyxLQUFJLENBQUN5QyxpQkFBTCxDQUF1QkwsS0FBdkIsQ0FBNkJDLFFBQTdCLEdBQXdDLFVBQXhDO0lBQ0FyQyxLQUFJLENBQUN5QyxpQkFBTCxDQUF1QkwsS0FBdkIsQ0FBNkJNLE1BQTdCLEdBQXNDLEdBQXRDO0lBQ0ExQyxLQUFJLENBQUN5QyxpQkFBTCxDQUF1QkwsS0FBdkIsQ0FBNkJHLEtBQTdCLEdBQXFDLE1BQXJDO0lBQ0F2QyxLQUFJLENBQUN5QyxpQkFBTCxDQUF1QkwsS0FBdkIsQ0FBNkJJLE1BQTdCLEdBQXNDLE1BQXRDO0lBQ0F4QyxLQUFJLENBQUN5QyxpQkFBTCxDQUF1QkwsS0FBdkIsQ0FBNkJPLGFBQTdCLEdBQTZDLE1BQTdDO0lBQ0EzQyxLQUFJLENBQUN5QyxpQkFBTCxDQUF1QlAsU0FBdkIsR0FBbUMscUJBQW5DOztJQUNBbEMsS0FBSSxDQUFDK0IsU0FBTCxDQUFlYSxXQUFmLENBQTJCNUMsS0FBSSxDQUFDeUMsaUJBQWhDO0lBRUE7Ozs7OztJQUlBekMsS0FBSSxDQUFDNkMsMEJBQUwsR0FBa0NiLFFBQVEsQ0FBQ0MsYUFBVCxDQUF1QixLQUF2QixDQUFsQztJQUNBakMsS0FBSSxDQUFDNkMsMEJBQUwsQ0FBZ0NULEtBQWhDLENBQXNDQyxRQUF0QyxHQUFpRCxVQUFqRDtJQUNBckMsS0FBSSxDQUFDNkMsMEJBQUwsQ0FBZ0NULEtBQWhDLENBQXNDTSxNQUF0QyxHQUErQyxHQUEvQztJQUNBMUMsS0FBSSxDQUFDNkMsMEJBQUwsQ0FBZ0NULEtBQWhDLENBQXNDRyxLQUF0QyxHQUE4QyxNQUE5QztJQUNBdkMsS0FBSSxDQUFDNkMsMEJBQUwsQ0FBZ0NULEtBQWhDLENBQXNDSSxNQUF0QyxHQUErQyxNQUEvQztJQUNBeEMsS0FBSSxDQUFDNkMsMEJBQUwsQ0FBZ0NULEtBQWhDLENBQXNDTyxhQUF0QyxHQUFzRCxNQUF0RDtJQUNBM0MsS0FBSSxDQUFDNkMsMEJBQUwsQ0FBZ0NYLFNBQWhDLEdBQTRDLCtCQUE1Qzs7SUFDQWxDLEtBQUksQ0FBQytCLFNBQUwsQ0FBZWEsV0FBZixDQUEyQjVDLEtBQUksQ0FBQzZDLDBCQUFoQztJQUVBOzs7Ozs7SUFJQTdDLEtBQUksQ0FBQzhDLHVCQUFMLEdBQStCLElBQS9CO0lBRUE7Ozs7O0lBSUE5QyxLQUFJLENBQUMrQyxjQUFMLEdBQXNCakQsT0FBTyxDQUFDa0QsYUFBOUI7SUFFQTs7Ozs7SUFJQWhELEtBQUksQ0FBQ2lELG9CQUFMLEdBQTRCN0MsZUFBZSxDQUFDOEMsbUJBQTVDO0lBRUE7Ozs7O0lBSUFsRCxLQUFJLENBQUNtRCx3QkFBTCxHQUFnQyxJQUFoQztJQUVBOzs7OztJQUlBbkQsS0FBSSxDQUFDb0QsUUFBTCxHQUFnQmhELGVBQWUsQ0FBQ2dELFFBQWhCLElBQTRCLElBQUlDLHNCQUFKLEVBQTVDO0lBRUE7Ozs7O0lBSUFyRCxLQUFJLENBQUNzRCxZQUFMLEdBQW9CbEQsZUFBZSxDQUFDa0QsWUFBaEIsSUFBZ0MsSUFBSUQsc0JBQUosRUFBcEQ7SUFFQTs7Ozs7SUFJQXJELEtBQUksQ0FBQ3VELFNBQUwsR0FBaUJuRCxlQUFlLENBQUNvRCxRQUFqQztJQUVBOzs7Ozs7SUFLQXhELEtBQUksQ0FBQ3lELGVBQUwsR0FBdUIsRUFBdkI7SUFFQTs7Ozs7SUFJQXpELEtBQUksQ0FBQzBELFNBQUwsR0FBaUIsSUFBakI7SUFFQTs7Ozs7SUFJQTFELEtBQUksQ0FBQzJELG9CQUFMLEdBQTRCLEVBQTVCO0lBRUE7Ozs7O0lBSUEzRCxLQUFJLENBQUM0RCxVQUFMLEdBQWtCLElBQUlDLHFCQUFKLENBQ2hCN0QsS0FBSSxDQUFDOEQsZUFBTCxDQUFxQnBELElBQXJCLENBQTBCVixLQUExQixDQURnQixFQUVoQkEsS0FBSSxDQUFDK0QsaUJBQUwsQ0FBdUJyRCxJQUF2QixDQUE0QlYsS0FBNUIsQ0FGZ0IsQ0FBbEI7O0lBS0FBLEtBQUksQ0FBQ2dFLGlCQUFMLENBQ0VDLHdCQUFZQyxVQURkLEVBRUVsRSxLQUFJLENBQUNtRSx3QkFGUDs7SUFJQW5FLEtBQUksQ0FBQ2dFLGlCQUFMLENBQXVCQyx3QkFBWUcsSUFBbkMsRUFBeUNwRSxLQUFJLENBQUNxRSxrQkFBOUM7O0lBQ0FyRSxLQUFJLENBQUNnRSxpQkFBTCxDQUF1QkMsd0JBQVlLLElBQW5DLEVBQXlDdEUsS0FBSSxDQUFDdUUsa0JBQTlDOztJQUNBdkUsS0FBSSxDQUFDZ0UsaUJBQUwsQ0FBdUJDLHdCQUFZTyxNQUFuQyxFQUEyQ3hFLEtBQUksQ0FBQ3lFLG9CQUFoRCxFQTFPaUIsQ0E0T2pCO0lBQ0E7OztJQUNBekUsS0FBSSxDQUFDMEUsYUFBTCxDQUFtQnRFLGVBQWUsQ0FBQ3VFLE1BQW5DOztJQUVBLElBQU1wRixHQUFHLEdBQUdTLEtBQVo7O0lBQ0EsSUFBSUYsT0FBTyxDQUFDOEUsSUFBUixJQUFnQixFQUFFOUUsT0FBTyxDQUFDOEUsSUFBUixZQUF3QkMsZ0JBQTFCLENBQXBCLEVBQXFEO01BQ25EL0UsT0FBTyxDQUFDOEUsSUFBUixDQUFhRSxJQUFiLENBQWtCLFVBQVVDLFdBQVYsRUFBcUI7UUFDckN4RixHQUFHLENBQUN5RixPQUFKLENBQVksSUFBSUgsZ0JBQUosQ0FBU0UsV0FBVCxDQUFaO01BQ0QsQ0FGRDtJQUdEOztJQUVEL0UsS0FBSSxDQUFDb0QsUUFBTCxDQUFjNkIsZ0JBQWQsQ0FDRUMsZ0NBQW9CQyxHQUR0QjtJQUVFOzs7SUFHQSxVQUFVQyxLQUFWLEVBQWU7TUFDYkEsS0FBSyxDQUFDQyxPQUFOLENBQWNDLE1BQWQsQ0FBcUIsSUFBckI7SUFDRCxDQUZELENBRUU1RSxJQUZGLENBRU9WLEtBRlAsQ0FMRjs7SUFVQUEsS0FBSSxDQUFDb0QsUUFBTCxDQUFjNkIsZ0JBQWQsQ0FDRUMsZ0NBQW9CSyxNQUR0QjtJQUVFOzs7SUFHQSxVQUFVSCxLQUFWLEVBQWU7TUFDYkEsS0FBSyxDQUFDQyxPQUFOLENBQWNDLE1BQWQsQ0FBcUIsSUFBckI7SUFDRCxDQUZELENBRUU1RSxJQUZGLENBRU9WLEtBRlAsQ0FMRjs7SUFVQUEsS0FBSSxDQUFDc0QsWUFBTCxDQUFrQjJCLGdCQUFsQixDQUNFQyxnQ0FBb0JDLEdBRHRCO0lBRUU7OztJQUdBLFVBQVVDLEtBQVYsRUFBZTtNQUNiQSxLQUFLLENBQUNDLE9BQU4sQ0FBY0MsTUFBZCxDQUFxQixJQUFyQjtJQUNELENBRkQsQ0FFRTVFLElBRkYsQ0FFT1YsS0FGUCxDQUxGOztJQVVBQSxLQUFJLENBQUNzRCxZQUFMLENBQWtCMkIsZ0JBQWxCLENBQ0VDLGdDQUFvQkssTUFEdEI7SUFFRTs7O0lBR0EsVUFBVUgsS0FBVixFQUFlO01BQ2JBLEtBQUssQ0FBQ0MsT0FBTixDQUFjQyxNQUFkLENBQXFCLElBQXJCO0lBQ0QsQ0FGRCxDQUVFNUUsSUFGRixDQUVPVixLQUZQLENBTEY7O0lBVUFBLEtBQUksQ0FBQ3VELFNBQUwsQ0FBZTBCLGdCQUFmLENBQ0VDLGdDQUFvQkMsR0FEdEI7SUFFRTs7O0lBR0EsVUFBVUMsS0FBVixFQUFlO01BQ2IsS0FBS0ksbUJBQUw7TUFDRTtNQUErQ0osS0FBSyxDQUFDQyxPQUR2RDtJQUdELENBSkQsQ0FJRTNFLElBSkYsQ0FJT1YsS0FKUCxDQUxGOztJQVlBQSxLQUFJLENBQUN1RCxTQUFMLENBQWUwQixnQkFBZixDQUNFQyxnQ0FBb0JLLE1BRHRCO0lBRUU7OztJQUdBLFVBQVVILEtBQVYsRUFBZTtNQUNiLElBQU1LLE9BQU87TUFBRztNQUNkTCxLQUFLLENBQUNDLE9BRFI7TUFHQSxJQUFNSyxFQUFFLEdBQUdELE9BQU8sQ0FBQ0UsS0FBUixFQUFYOztNQUNBLElBQUlELEVBQUUsS0FBSzdFLFNBQVgsRUFBc0I7UUFDcEIsT0FBTyxLQUFLNEMsZUFBTCxDQUFxQmlDLEVBQUUsQ0FBQ0UsUUFBSCxFQUFyQixDQUFQO01BQ0Q7O01BQ0RSLEtBQUssQ0FBQ0MsT0FBTixDQUFjQyxNQUFkLENBQXFCLElBQXJCO0lBQ0QsQ0FURCxDQVNFNUUsSUFURixDQVNPVixLQVRQLENBTEY7O0lBaUJBQSxLQUFJLENBQUNvRCxRQUFMLENBQWMvRCxPQUFkO0lBQ0U7Ozs7SUFJQSxVQUFVd0csT0FBVixFQUFpQjtNQUNmQSxPQUFPLENBQUNQLE1BQVIsQ0FBZSxJQUFmO0lBQ0QsQ0FGRCxDQUVFNUUsSUFGRixDQUVPVixLQUZQLENBTEY7O0lBVUFBLEtBQUksQ0FBQ3NELFlBQUwsQ0FBa0JqRSxPQUFsQjtJQUNFOzs7O0lBSUEsVUFBVXlHLFdBQVYsRUFBcUI7TUFDbkJBLFdBQVcsQ0FBQ1IsTUFBWixDQUFtQixJQUFuQjtJQUNELENBRkQsQ0FFRTVFLElBRkYsQ0FFT1YsS0FGUCxDQUxGOztJQVVBQSxLQUFJLENBQUN1RCxTQUFMLENBQWVsRSxPQUFmLENBQXVCVyxLQUFJLENBQUN3RixtQkFBTCxDQUF5QjlFLElBQXpCLENBQThCVixLQUE5QixDQUF2Qjs7O0VBQ0Q7RUFFRDs7Ozs7O0VBSUErRjtJQUNFLE1BQU0sSUFBSUMsS0FBSixDQUFVLGlEQUFWLENBQU47RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7RUFLQUQsOENBQVdGLE9BQVgsRUFBa0I7SUFDaEIsS0FBS0ksV0FBTCxHQUFtQkMsSUFBbkIsQ0FBd0JMLE9BQXhCO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7Ozs7OztFQVNBRSxrREFBZUQsV0FBZixFQUEwQjtJQUN4QixLQUFLSyxlQUFMLEdBQXVCRCxJQUF2QixDQUE0QkosV0FBNUI7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7OztFQU9BQyw0Q0FBUy9HLEtBQVQsRUFBYztJQUNaLElBQU1RLE1BQU0sR0FBRyxLQUFLNEcsYUFBTCxHQUFxQmhILFNBQXJCLEVBQWY7SUFDQUksTUFBTSxDQUFDMEcsSUFBUCxDQUFZbEgsS0FBWjtFQUNELENBSEQ7RUFLQTs7Ozs7O0VBSUErRyxtREFBZ0JYLEtBQWhCLEVBQXFCO0lBQ25COUYsbUJBQW1CLENBQUM4RixLQUFLLENBQUNwRyxLQUFQLEVBQWMsSUFBZCxDQUFuQjtFQUNELENBRkQ7RUFJQTs7Ozs7OztFQUtBK0csOENBQVdOLE9BQVgsRUFBa0I7SUFDaEIsS0FBS1ksV0FBTCxHQUFtQkgsSUFBbkIsQ0FBd0JULE9BQXhCO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7O0VBS0FNLHVEQUFvQk4sT0FBcEIsRUFBMkI7SUFDekIsSUFBTUMsRUFBRSxHQUFHRCxPQUFPLENBQUNFLEtBQVIsRUFBWDs7SUFDQSxJQUFJRCxFQUFFLEtBQUs3RSxTQUFYLEVBQXNCO01BQ3BCLEtBQUs0QyxlQUFMLENBQXFCaUMsRUFBRSxDQUFDRSxRQUFILEVBQXJCLElBQXNDSCxPQUF0QztJQUNEOztJQUNEQSxPQUFPLENBQUNILE1BQVIsQ0FBZSxJQUFmO0VBQ0QsQ0FORDtFQVFBOzs7Ozs7RUFJQVM7SUFDRSxLQUFLTyxTQUFMLENBQWUsSUFBZjs7SUFDQXZHLGlCQUFNd0csZUFBTixDQUFxQkMsSUFBckIsQ0FBcUIsSUFBckI7RUFDRCxDQUhEO0VBS0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0VBa0JBVCx5REFBc0JVLEtBQXRCLEVBQTZCQyxRQUE3QixFQUF1Q0MsV0FBdkMsRUFBa0Q7SUFDaEQsSUFBSSxDQUFDLEtBQUtqRixXQUFOLElBQXFCLENBQUMsS0FBS2dDLFNBQS9CLEVBQTBDO01BQ3hDO0lBQ0Q7O0lBQ0QsSUFBTWtELFVBQVUsR0FBRyxLQUFLQyw4QkFBTCxDQUFvQ0osS0FBcEMsQ0FBbkI7SUFDQUUsV0FBVyxHQUFHQSxXQUFXLEtBQUs5RixTQUFoQixHQUE0QjhGLFdBQTVCLEdBQTBDLEVBQXhEO0lBQ0EsSUFBTUcsWUFBWSxHQUNoQkgsV0FBVyxDQUFDRyxZQUFaLEtBQTZCakcsU0FBN0IsR0FBeUM4RixXQUFXLENBQUNHLFlBQXJELEdBQW9FLENBRHRFO0lBRUEsSUFBTUMsV0FBVyxHQUNmSixXQUFXLENBQUNJLFdBQVosS0FBNEJsRyxTQUE1QixHQUF3QzhGLFdBQVcsQ0FBQ0ksV0FBcEQsR0FBa0VDLGVBRHBFO0lBRUEsSUFBTUMsWUFBWSxHQUFHTixXQUFXLENBQUNNLFlBQVosS0FBNkIsS0FBbEQ7SUFDQSxPQUFPLEtBQUt2RCxTQUFMLENBQWV3RCwwQkFBZixDQUNMTixVQURLLEVBRUwsS0FBS2xGLFdBRkEsRUFHTG9GLFlBSEssRUFJTEcsWUFKSyxFQUtMUCxRQUxLLEVBTUwsSUFOSyxFQU9MSyxXQVBLLEVBUUwsSUFSSyxDQUFQO0VBVUQsQ0FyQkQ7RUF1QkE7Ozs7Ozs7Ozs7RUFRQWhCLHNEQUFtQlUsS0FBbkIsRUFBMEJFLFdBQTFCLEVBQXFDO0lBQ25DLElBQU1RLFFBQVEsR0FBRyxFQUFqQjtJQUNBLEtBQUtDLHFCQUFMLENBQ0VYLEtBREYsRUFFRSxVQUFVWSxPQUFWLEVBQWlCO01BQ2ZGLFFBQVEsQ0FBQ2pCLElBQVQsQ0FBY21CLE9BQWQ7SUFDRCxDQUpILEVBS0VWLFdBTEY7SUFPQSxPQUFPUSxRQUFQO0VBQ0QsQ0FWRDtFQVlBOzs7Ozs7O0VBS0FwQjtJQUNFLElBQU12RyxNQUFNLEdBQUcsRUFBZjs7SUFDQSxTQUFTOEgsYUFBVCxDQUF1QkMsVUFBdkIsRUFBaUM7TUFDL0JBLFVBQVUsQ0FBQ2xJLE9BQVgsQ0FBbUIsVUFBVUwsS0FBVixFQUFlO1FBQ2hDLElBQUlBLEtBQUssWUFBWUcsaUJBQXJCLEVBQWlDO1VBQy9CbUksYUFBYSxDQUFDdEksS0FBSyxDQUFDSSxTQUFOLEVBQUQsQ0FBYjtRQUNELENBRkQsTUFFTztVQUNMSSxNQUFNLENBQUMwRyxJQUFQLENBQVlsSCxLQUFaO1FBQ0Q7TUFDRixDQU5EO0lBT0Q7O0lBQ0RzSSxhQUFhLENBQUMsS0FBS2xJLFNBQUwsRUFBRCxDQUFiO0lBQ0EsT0FBT0ksTUFBUDtFQUNELENBYkQ7RUFlQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0VBNEJBdUcsdURBQW9CVSxLQUFwQixFQUEyQkMsUUFBM0IsRUFBcUNDLFdBQXJDLEVBQWdEO0lBQzlDLElBQUksQ0FBQyxLQUFLakYsV0FBTixJQUFxQixDQUFDLEtBQUtnQyxTQUEvQixFQUEwQztNQUN4QztJQUNEOztJQUNELElBQU01RCxPQUFPLEdBQUc2RyxXQUFXLElBQUksRUFBL0I7SUFDQSxJQUFNRyxZQUFZLEdBQ2hCaEgsT0FBTyxDQUFDZ0gsWUFBUixLQUF5QmpHLFNBQXpCLEdBQXFDZixPQUFPLENBQUNnSCxZQUE3QyxHQUE0RCxDQUQ5RDtJQUVBLElBQU1DLFdBQVcsR0FBR2pILE9BQU8sQ0FBQ2lILFdBQVIsSUFBdUJDLGVBQTNDO0lBQ0EsT0FBTyxLQUFLdEQsU0FBTCxDQUFlOEQsbUJBQWYsQ0FDTGYsS0FESyxFQUVMLEtBQUsvRSxXQUZBLEVBR0xvRixZQUhLLEVBSUxKLFFBSkssRUFLTEssV0FMSyxDQUFQO0VBT0QsQ0FmRDtFQWlCQTs7Ozs7Ozs7OztFQVFBaEIscURBQWtCVSxLQUFsQixFQUF5QkUsV0FBekIsRUFBb0M7SUFDbEMsSUFBSSxDQUFDLEtBQUtqRixXQUFOLElBQXFCLENBQUMsS0FBS2dDLFNBQS9CLEVBQTBDO01BQ3hDLE9BQU8sS0FBUDtJQUNEOztJQUNELElBQU1rRCxVQUFVLEdBQUcsS0FBS0MsOEJBQUwsQ0FBb0NKLEtBQXBDLENBQW5CO0lBQ0FFLFdBQVcsR0FBR0EsV0FBVyxLQUFLOUYsU0FBaEIsR0FBNEI4RixXQUE1QixHQUEwQyxFQUF4RDtJQUNBLElBQU1JLFdBQVcsR0FDZkosV0FBVyxDQUFDSSxXQUFaLEtBQTRCbEcsU0FBNUIsR0FBd0M4RixXQUFXLENBQUNJLFdBQXBELEdBQWtFQyxlQURwRTtJQUVBLElBQU1GLFlBQVksR0FDaEJILFdBQVcsQ0FBQ0csWUFBWixLQUE2QmpHLFNBQTdCLEdBQXlDOEYsV0FBVyxDQUFDRyxZQUFyRCxHQUFvRSxDQUR0RTtJQUVBLElBQU1HLFlBQVksR0FBR04sV0FBVyxDQUFDTSxZQUFaLEtBQTZCLEtBQWxEO0lBQ0EsT0FBTyxLQUFLdkQsU0FBTCxDQUFlK0Qsc0JBQWYsQ0FDTGIsVUFESyxFQUVMLEtBQUtsRixXQUZBLEVBR0xvRixZQUhLLEVBSUxHLFlBSkssRUFLTEYsV0FMSyxFQU1MLElBTkssQ0FBUDtFQVFELENBbkJEO0VBcUJBOzs7Ozs7OztFQU1BaEIsc0RBQW1CWCxLQUFuQixFQUF3QjtJQUN0QixPQUFPLEtBQUtzQyxzQkFBTCxDQUE0QixLQUFLQyxhQUFMLENBQW1CdkMsS0FBbkIsQ0FBNUIsQ0FBUDtFQUNELENBRkQ7RUFJQTs7Ozs7OztFQUtBVyw4REFBMkJYLEtBQTNCLEVBQWdDO0lBQzlCLE9BQU8sS0FBS3lCLDhCQUFMLENBQW9DLEtBQUtjLGFBQUwsQ0FBbUJ2QyxLQUFuQixDQUFwQyxDQUFQO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BVyxpREFBY1gsS0FBZCxFQUFtQjtJQUNqQixJQUFNd0MsZ0JBQWdCLEdBQUcsS0FBSzdGLFNBQUwsQ0FBZThGLHFCQUFmLEVBQXpCO0lBQ0EsSUFBTUMsYUFBYSxHQUNqQjtJQUNBLG9CQUFvQjFDLEtBQXBCO0lBQ0k7SUFBMkJBLEtBQUQsQ0FBUTJDLGNBQVIsQ0FBdUIsQ0FBdkIsQ0FEOUI7SUFFSTtJQUEyQjNDLEtBSmpDO0lBTUEsT0FBTyxDQUNMMEMsYUFBYSxDQUFDRSxPQUFkLEdBQXdCSixnQkFBZ0IsQ0FBQ0ssSUFEcEMsRUFFTEgsYUFBYSxDQUFDSSxPQUFkLEdBQXdCTixnQkFBZ0IsQ0FBQ08sR0FGcEMsQ0FBUDtFQUlELENBWkQ7RUFjQTs7Ozs7Ozs7Ozs7RUFTQXBDO0lBQ0U7TUFBTztNQUNMLEtBQUtxQyxHQUFMLENBQVNuRSx3QkFBWU8sTUFBckI7SUFERjtFQUdELENBSkQ7RUFNQTs7Ozs7Ozs7O0VBT0F1QjtJQUNFLElBQU1zQyxNQUFNLEdBQUcsS0FBS0MsU0FBTCxFQUFmOztJQUNBLElBQUlELE1BQU0sS0FBS3hILFNBQWYsRUFBMEI7TUFDeEIsT0FBTyxPQUFPd0gsTUFBUCxLQUFrQixRQUFsQixHQUNIckcsUUFBUSxDQUFDdUcsY0FBVCxDQUF3QkYsTUFBeEIsQ0FERyxHQUVIQSxNQUZKO0lBR0QsQ0FKRCxNQUlPO01BQ0wsT0FBTyxJQUFQO0lBQ0Q7RUFDRixDQVREO0VBV0E7Ozs7Ozs7OztFQU9BdEMsMERBQXVCVSxLQUF2QixFQUE0QjtJQUMxQixPQUFPLDRCQUNMLEtBQUtJLDhCQUFMLENBQW9DSixLQUFwQyxDQURLLEVBRUwsS0FBSytCLE9BQUwsR0FBZUMsYUFBZixFQUZLLENBQVA7RUFJRCxDQUxEO0VBT0E7Ozs7Ozs7O0VBTUExQyxrRUFBK0JVLEtBQS9CLEVBQW9DO0lBQ2xDLElBQU1pQyxVQUFVLEdBQUcsS0FBS2hILFdBQXhCOztJQUNBLElBQUksQ0FBQ2dILFVBQUwsRUFBaUI7TUFDZixPQUFPLElBQVA7SUFDRCxDQUZELE1BRU87TUFDTCxPQUFPLHNCQUNMQSxVQUFVLENBQUNDLDBCQUROLEVBRUxsQyxLQUFLLENBQUNtQyxLQUFOLEVBRkssQ0FBUDtJQUlEO0VBQ0YsQ0FWRDtFQVlBOzs7Ozs7OztFQU1BN0M7SUFDRSxPQUFPLEtBQUszQyxRQUFaO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BMkM7SUFDRSxPQUFPLEtBQUt4QyxTQUFaO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7Ozs7O0VBUUF3QyxrREFBZUwsRUFBZixFQUFpQjtJQUNmLElBQU1ELE9BQU8sR0FBRyxLQUFLaEMsZUFBTCxDQUFxQmlDLEVBQUUsQ0FBQ0UsUUFBSCxFQUFyQixDQUFoQjtJQUNBLE9BQU9ILE9BQU8sS0FBSzVFLFNBQVosR0FBd0I0RSxPQUF4QixHQUFrQyxJQUF6QztFQUNELENBSEQ7RUFLQTs7Ozs7Ozs7OztFQVFBTTtJQUNFLE9BQU8sS0FBS3pDLFlBQVo7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7O0VBTUF5QztJQUNFO01BQU87TUFBMkIsS0FBS3FDLEdBQUwsQ0FBU25FLHdCQUFZQyxVQUFyQjtJQUFsQztFQUNELENBRkQ7RUFJQTs7Ozs7OztFQUtBNkIsNkNBQVV2RyxNQUFWLEVBQWdCO0lBQ2QsSUFBTXFKLEtBQUssR0FBRyxLQUFLekMsYUFBTCxFQUFkOztJQUNBLElBQUk1RyxNQUFNLFlBQVk2RCxzQkFBdEIsRUFBa0M7TUFDaEN3RixLQUFLLENBQUNDLFNBQU4sQ0FBZ0J0SixNQUFoQjtNQUNBO0lBQ0Q7O0lBRUQsSUFBTXVKLFVBQVUsR0FBR0YsS0FBSyxDQUFDekosU0FBTixFQUFuQjtJQUNBMkosVUFBVSxDQUFDQyxLQUFYO0lBQ0FELFVBQVUsQ0FBQ0UsTUFBWCxDQUFrQnpKLE1BQWxCO0VBQ0QsQ0FWRDtFQVlBOzs7Ozs7O0VBS0F1RztJQUNFLElBQU12RyxNQUFNLEdBQUcsS0FBSzRHLGFBQUwsR0FBcUJoSCxTQUFyQixFQUFmO0lBQ0EsT0FBT0ksTUFBUDtFQUNELENBSEQ7RUFLQTs7Ozs7RUFHQXVHO0lBQ0UsSUFBTW1ELGdCQUFnQixHQUFHLEtBQUs5QyxhQUFMLEdBQXFCK0MsbUJBQXJCLEVBQXpCOztJQUNBLEtBQUssSUFBSXpKLENBQUMsR0FBRyxDQUFSLEVBQVdDLEVBQUUsR0FBR3VKLGdCQUFnQixDQUFDdEosTUFBdEMsRUFBOENGLENBQUMsR0FBR0MsRUFBbEQsRUFBc0QsRUFBRUQsQ0FBeEQsRUFBMkQ7TUFDekQsSUFBTTBKLEtBQUssR0FBR0YsZ0JBQWdCLENBQUN4SixDQUFELENBQTlCOztNQUNBLElBQUksQ0FBQzBKLEtBQUssQ0FBQ0MsT0FBWCxFQUFvQjtRQUNsQjtNQUNEOztNQUNELElBQU1DLFFBQVEsR0FBR0YsS0FBSyxDQUFDcEssS0FBTixDQUFZdUssV0FBWixFQUFqQjs7TUFDQSxJQUFJRCxRQUFRLElBQUksQ0FBQ0EsUUFBUSxDQUFDRSxLQUExQixFQUFpQztRQUMvQixPQUFPLElBQVA7TUFDRDs7TUFDRCxJQUFNQyxNQUFNO01BQUc7TUFDYkwsS0FBSyxDQUFDcEssS0FEeUQsQ0FFL0QwSyxTQUYrRCxFQUFqRTs7TUFHQSxJQUFJRCxNQUFNLElBQUlBLE1BQU0sQ0FBQ0UsT0FBckIsRUFBOEI7UUFDNUIsT0FBTyxJQUFQO01BQ0Q7SUFDRjs7SUFDRCxPQUFPLEtBQVA7RUFDRCxDQW5CRDtFQXFCQTs7Ozs7Ozs7O0VBT0E1RCwwREFBdUJhLFVBQXZCLEVBQWlDO0lBQy9CLElBQU1nRCxjQUFjLEdBQUcsOEJBQ3JCaEQsVUFEcUIsRUFFckIsS0FBSzRCLE9BQUwsR0FBZUMsYUFBZixFQUZxQixDQUF2QjtJQUlBLE9BQU8sS0FBS29CLDhCQUFMLENBQW9DRCxjQUFwQyxDQUFQO0VBQ0QsQ0FORDtFQVFBOzs7Ozs7OztFQU1BN0Qsa0VBQStCYSxVQUEvQixFQUF5QztJQUN2QyxJQUFNOEIsVUFBVSxHQUFHLEtBQUtoSCxXQUF4Qjs7SUFDQSxJQUFJLENBQUNnSCxVQUFMLEVBQWlCO01BQ2YsT0FBTyxJQUFQO0lBQ0QsQ0FGRCxNQUVPO01BQ0wsT0FBTyxzQkFDTEEsVUFBVSxDQUFDb0IsMEJBRE4sRUFFTGxELFVBQVUsQ0FBQ2dDLEtBQVgsQ0FBaUIsQ0FBakIsRUFBb0IsQ0FBcEIsQ0FGSyxDQUFQO0lBSUQ7RUFDRixDQVZEO0VBWUE7Ozs7OztFQUlBN0M7SUFDRSxPQUFPLEtBQUtyQyxTQUFaO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BcUM7SUFDRTtNQUFPO01BQ0wsS0FBS3FDLEdBQUwsQ0FBU25FLHdCQUFZSyxJQUFyQjtJQURGO0VBR0QsQ0FKRDtFQU1BOzs7Ozs7Ozs7RUFPQXlCO0lBQ0U7TUFBTztNQUFxQixLQUFLcUMsR0FBTCxDQUFTbkUsd0JBQVlHLElBQXJCO0lBQTVCO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7O0VBS0EyQjtJQUNFLE9BQU8sS0FBS2hFLFNBQVo7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7OztFQU9BZ0U7SUFDRSxPQUFPLEtBQUt0RCxpQkFBWjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7O0VBT0FzRDtJQUNFLE9BQU8sS0FBS2xELDBCQUFaO0VBQ0QsQ0FGRDtFQUlBOzs7OztFQUdBa0Q7SUFDRSxJQUFNZ0UsYUFBYSxHQUFHLEtBQUtDLGdCQUFMLEVBQXRCO0lBQ0EsT0FBT0QsYUFBYSxHQUFHQSxhQUFhLENBQUNFLGFBQWpCLEdBQWlDakksUUFBckQ7RUFDRCxDQUhEO0VBS0E7Ozs7Ozs7OztFQU9BK0QsbURBQWdCbUUsSUFBaEIsRUFBc0JDLGFBQXRCLEVBQXFDQyxVQUFyQyxFQUFpREMsY0FBakQsRUFBK0Q7SUFDN0QsT0FBTyxnQ0FDTCxLQUFLM0ksV0FEQSxFQUVMd0ksSUFGSyxFQUdMQyxhQUhLLEVBSUxDLFVBSkssRUFLTEMsY0FMSyxDQUFQO0VBT0QsQ0FSRDtFQVVBOzs7Ozs7RUFJQXRFLHNEQUFtQnVFLFlBQW5CLEVBQWlDQyxRQUFqQyxFQUF5QztJQUN2QyxJQUFNQyxJQUFJLEdBQUdELFFBQVEsSUFBSUQsWUFBWSxDQUFDRSxJQUF0QztJQUNBLElBQU1DLGVBQWUsR0FBRyxJQUFJQywyQkFBSixDQUFvQkYsSUFBcEIsRUFBMEIsSUFBMUIsRUFBZ0NGLFlBQWhDLENBQXhCO0lBQ0EsS0FBS0sscUJBQUwsQ0FBMkJGLGVBQTNCO0VBQ0QsQ0FKRDtFQU1BOzs7OztFQUdBMUUseURBQXNCMEUsZUFBdEIsRUFBcUM7SUFDbkMsSUFBSSxDQUFDLEtBQUsvSSxXQUFWLEVBQXVCO01BQ3JCO01BQ0E7TUFDQTtJQUNEOztJQUNELElBQU1rSixhQUFhO0lBQUc7SUFDcEJILGVBQWUsQ0FBQ0csYUFEbEI7SUFHQSxJQUFNQyxTQUFTLEdBQUdELGFBQWEsQ0FBQ0osSUFBaEM7O0lBQ0EsSUFDRUssU0FBUyxLQUFLQyx1QkFBaUJDLFdBQS9CLElBQ0FGLFNBQVMsS0FBS0csc0JBQVVDLEtBRHhCLElBRUFKLFNBQVMsS0FBS0csc0JBQVVFLE9BSDFCLEVBSUU7TUFDQSxJQUFNQyxHQUFHLEdBQUcsS0FBS0MsZ0JBQUwsRUFBWjtNQUNBLElBQU1DLFFBQVEsR0FBRyxLQUFLdEosU0FBTCxDQUFldUosV0FBZixHQUNiLEtBQUt2SixTQUFMLENBQWV1SixXQUFmLEVBRGEsR0FFYkgsR0FGSjtNQUdBLElBQU05QyxNQUFNO01BQUc7TUFBcUJ1QyxhQUFhLENBQUN2QyxNQUFsRDs7TUFDQSxLQUNFO01BQ0E7TUFDQSxLQUFLeEYsMEJBQUwsQ0FBZ0MwSSxRQUFoQyxDQUF5Q2xELE1BQXpDLEtBQ0E7TUFDQTtNQUNBO01BQ0E7TUFDQSxDQUFDLENBQUNnRCxRQUFRLEtBQUtGLEdBQWIsR0FBbUJBLEdBQUcsQ0FBQ0ssZUFBdkIsR0FBeUNILFFBQTFDLEVBQW9ERSxRQUFwRCxDQUE2RGxELE1BQTdELENBUkgsRUFTRTtRQUNBO01BQ0Q7SUFDRjs7SUFDRG9DLGVBQWUsQ0FBQy9CLFVBQWhCLEdBQTZCLEtBQUtoSCxXQUFsQzs7SUFDQSxJQUFJLEtBQUsrSixhQUFMLENBQW1CaEIsZUFBbkIsTUFBd0MsS0FBNUMsRUFBbUQ7TUFDakQsSUFBTWlCLGlCQUFpQixHQUFHLEtBQUt2RixlQUFMLEdBQXVCMUcsUUFBdkIsR0FBa0NtSixLQUFsQyxFQUExQjs7TUFDQSxLQUFLLElBQUlsSixDQUFDLEdBQUdnTSxpQkFBaUIsQ0FBQzlMLE1BQWxCLEdBQTJCLENBQXhDLEVBQTJDRixDQUFDLElBQUksQ0FBaEQsRUFBbURBLENBQUMsRUFBcEQsRUFBd0Q7UUFDdEQsSUFBTW9HLFdBQVcsR0FBRzRGLGlCQUFpQixDQUFDaE0sQ0FBRCxDQUFyQzs7UUFDQSxJQUNFb0csV0FBVyxDQUFDNkYsTUFBWixPQUF5QixJQUF6QixJQUNBLENBQUM3RixXQUFXLENBQUM4RixTQUFaLEVBREQsSUFFQSxDQUFDLEtBQUs1QixnQkFBTCxFQUhILEVBSUU7VUFDQTtRQUNEOztRQUNELElBQU02QixJQUFJLEdBQUcvRixXQUFXLENBQUNnRyxXQUFaLENBQXdCckIsZUFBeEIsQ0FBYjs7UUFDQSxJQUFJLENBQUNvQixJQUFELElBQVNwQixlQUFlLENBQUNzQixrQkFBN0IsRUFBaUQ7VUFDL0M7UUFDRDtNQUNGO0lBQ0Y7RUFDRixDQW5ERDtFQXFEQTs7Ozs7RUFHQWhHO0lBQ0UsSUFBTTJDLFVBQVUsR0FBRyxLQUFLaEgsV0FBeEIsQ0FERixDQUdFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTs7SUFDQSxJQUFNc0ssU0FBUyxHQUFHLEtBQUtwSSxVQUF2Qjs7SUFDQSxJQUFJLENBQUNvSSxTQUFTLENBQUNDLE9BQVYsRUFBTCxFQUEwQjtNQUN4QixJQUFJQyxlQUFlLEdBQUcsS0FBS3ZMLGdCQUEzQjtNQUNBLElBQUl3TCxXQUFXLEdBQUdELGVBQWxCOztNQUNBLElBQUl4RCxVQUFKLEVBQWdCO1FBQ2QsSUFBTTBELEtBQUssR0FBRzFELFVBQVUsQ0FBQzJELFNBQXpCOztRQUNBLElBQUlELEtBQUssQ0FBQ0UscUJBQVNDLFNBQVYsQ0FBTCxJQUE2QkgsS0FBSyxDQUFDRSxxQkFBU0UsV0FBVixDQUF0QyxFQUE4RDtVQUM1RCxJQUFNQyxnQkFBZ0IsR0FBR3BMLElBQUksQ0FBQ0MsR0FBTCxLQUFhb0gsVUFBVSxDQUFDZ0UsSUFBeEIsR0FBK0IsQ0FBeEQ7VUFDQVIsZUFBZSxHQUFHTyxnQkFBZ0IsR0FBRyxDQUFILEdBQU8sQ0FBekM7VUFDQU4sV0FBVyxHQUFHTSxnQkFBZ0IsR0FBRyxDQUFILEdBQU8sQ0FBckM7UUFDRDtNQUNGOztNQUNELElBQUlULFNBQVMsQ0FBQ1csZUFBVixLQUE4QlQsZUFBbEMsRUFBbUQ7UUFDakRGLFNBQVMsQ0FBQ1ksWUFBVixHQURpRCxDQUN2Qjs7UUFDMUJaLFNBQVMsQ0FBQ2EsYUFBVixDQUF3QlgsZUFBeEIsRUFBeUNDLFdBQXpDO01BQ0Q7SUFDRjs7SUFFRCxJQUFJekQsVUFBVSxJQUFJLEtBQUtoRixTQUFuQixJQUFnQyxDQUFDZ0YsVUFBVSxDQUFDb0UsT0FBaEQsRUFBeUQ7TUFDdkQsSUFBSSxLQUFLeE0sZUFBTCxLQUF5QixJQUE3QixFQUFtQztRQUNqQyxJQUFJLEtBQUt5TSxXQUFMLENBQWlCQyx1QkFBZ0JDLGNBQWpDLENBQUosRUFBc0Q7VUFDcEQsS0FBS3ZKLFNBQUwsQ0FBZXdKLG1CQUFmLENBQ0VGLHVCQUFnQkMsY0FEbEIsRUFFRXZFLFVBRkY7UUFJRDs7UUFDRCxJQUFJLEtBQUtuSSxPQUFMLEtBQWlCLEtBQXJCLEVBQTRCO1VBQzFCLEtBQUtBLE9BQUwsR0FBZSxJQUFmO1VBQ0EsS0FBS2tMLGFBQUwsQ0FDRSxJQUFJMEIsb0JBQUosQ0FBYUMseUJBQWFDLE9BQTFCLEVBQW1DLElBQW5DLEVBQXlDM0UsVUFBekMsQ0FERjtRQUdEO01BQ0YsQ0FiRCxNQWFPLElBQUksS0FBS25JLE9BQUwsS0FBaUIsSUFBckIsRUFBMkI7UUFDaEMsS0FBS0EsT0FBTCxHQUFlLEtBQWY7UUFDQSxLQUFLa0wsYUFBTCxDQUNFLElBQUkwQixvQkFBSixDQUFhQyx5QkFBYUUsU0FBMUIsRUFBcUMsSUFBckMsRUFBMkM1RSxVQUEzQyxDQURGO01BR0Q7SUFDRjs7SUFFRCxJQUFNNkUsbUJBQW1CLEdBQUcsS0FBSzVKLG9CQUFqQzs7SUFDQSxLQUFLLElBQUlqRSxDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUc0TixtQkFBbUIsQ0FBQzNOLE1BQXpDLEVBQWlERixDQUFDLEdBQUdDLEVBQXJELEVBQXlELEVBQUVELENBQTNELEVBQThEO01BQzVENk4sbUJBQW1CLENBQUM3TixDQUFELENBQW5CLENBQXVCLElBQXZCLEVBQTZCZ0osVUFBN0I7SUFDRDs7SUFDRDZFLG1CQUFtQixDQUFDM04sTUFBcEIsR0FBNkIsQ0FBN0I7RUFDRCxDQXpERDtFQTJEQTs7Ozs7RUFHQW1HO0lBQ0UsSUFBSSxLQUFLeUMsT0FBTCxNQUFrQixDQUFDLEtBQUtBLE9BQUwsR0FBZWdGLFlBQWYsRUFBdkIsRUFBc0Q7TUFDcEQsS0FBS2hGLE9BQUwsR0FBZWlGLGtCQUFmLENBQWtDLENBQWxDO0lBQ0Q7O0lBRUQsS0FBS0MsTUFBTDtFQUNELENBTkQ7RUFRQTs7Ozs7RUFHQTNIO0lBQ0UsSUFBSSxLQUFLakQsdUJBQVQsRUFBa0M7TUFDaEMsS0FBSyxJQUFJcEQsQ0FBQyxHQUFHLENBQVIsRUFBV0MsRUFBRSxHQUFHLEtBQUt3RCx3QkFBTCxDQUE4QnZELE1BQW5ELEVBQTJERixDQUFDLEdBQUdDLEVBQS9ELEVBQW1FLEVBQUVELENBQXJFLEVBQXdFO1FBQ3RFLDJCQUFjLEtBQUt5RCx3QkFBTCxDQUE4QnpELENBQTlCLENBQWQ7TUFDRDs7TUFDRCxLQUFLeUQsd0JBQUwsR0FBZ0MsSUFBaEM7TUFDQSxLQUFLcEIsU0FBTCxDQUFlNEwsbUJBQWYsQ0FDRTNDLHNCQUFVNEMsV0FEWixFQUVFLEtBQUtwTix3QkFGUDtNQUlBLEtBQUt1QixTQUFMLENBQWU0TCxtQkFBZixDQUNFM0Msc0JBQVVDLEtBRFosRUFFRSxLQUFLekssd0JBRlA7TUFJQSxLQUFLc0MsdUJBQUwsQ0FBNkIrSyxPQUE3QjtNQUNBLEtBQUsvSyx1QkFBTCxHQUErQixJQUEvQjtNQUNBLHFCQUFXLEtBQUtmLFNBQWhCO0lBQ0QsQ0FqQkgsQ0FtQkU7SUFDQTtJQUNBO0lBQ0E7OztJQUVBLElBQU1nSSxhQUFhLEdBQUcsS0FBS0MsZ0JBQUwsRUFBdEI7O0lBQ0EsSUFBSSxDQUFDRCxhQUFMLEVBQW9CO01BQ2xCLElBQUksS0FBS3JHLFNBQVQsRUFBb0I7UUFDbEJvSyxZQUFZLENBQUMsS0FBSzdNLHdCQUFOLENBQVo7UUFDQSxLQUFLQSx3QkFBTCxHQUFnQ0osU0FBaEM7UUFDQSxLQUFLOEMsb0JBQUwsQ0FBMEIvRCxNQUExQixHQUFtQyxDQUFuQztRQUNBLEtBQUs4RCxTQUFMLENBQWVtSyxPQUFmO1FBQ0EsS0FBS25LLFNBQUwsR0FBaUIsSUFBakI7TUFDRDs7TUFDRCxJQUFJLEtBQUt4QyxrQkFBVCxFQUE2QjtRQUMzQjZNLG9CQUFvQixDQUFDLEtBQUs3TSxrQkFBTixDQUFwQjtRQUNBLEtBQUtBLGtCQUFMLEdBQTBCTCxTQUExQjtNQUNEO0lBQ0YsQ0FaRCxNQVlPO01BQ0xrSixhQUFhLENBQUNuSCxXQUFkLENBQTBCLEtBQUtiLFNBQS9COztNQUNBLElBQUksQ0FBQyxLQUFLMkIsU0FBVixFQUFxQjtRQUNuQixLQUFLQSxTQUFMLEdBQWlCLEtBQUtzSyxjQUFMLEVBQWpCO01BQ0Q7O01BRUQsS0FBS2xMLHVCQUFMLEdBQStCLElBQUltTCxrQ0FBSixDQUM3QixJQUQ2QixFQUU3QixLQUFLbEwsY0FGd0IsQ0FBL0I7O01BSUEsS0FBSyxJQUFNbUwsR0FBWCxJQUFrQkMsK0JBQWxCLEVBQXVDO1FBQ3JDLEtBQUtyTCx1QkFBTCxDQUE2Qm1DLGdCQUE3QixDQUNFa0osZ0NBQW9CRCxHQUFwQixDQURGLEVBRUUsS0FBS3ZELHFCQUFMLENBQTJCakssSUFBM0IsQ0FBZ0MsSUFBaEMsQ0FGRjtNQUlEOztNQUNELEtBQUtxQixTQUFMLENBQWVrRCxnQkFBZixDQUNFK0Ysc0JBQVU0QyxXQURaLEVBRUUsS0FBS3BOLHdCQUZQLEVBR0UsS0FIRjtNQUtBLEtBQUt1QixTQUFMLENBQWVrRCxnQkFBZixDQUNFK0Ysc0JBQVVDLEtBRFosRUFFRSxLQUFLekssd0JBRlAsRUFHRTROLCtCQUEwQjtRQUFDQyxPQUFPLEVBQUU7TUFBVixDQUExQixHQUE2QyxLQUgvQztNQU1BLElBQU1DLFdBQVcsR0FBRyxLQUFLbEQsZ0JBQUwsR0FBd0JrRCxXQUE1QztNQUNBLElBQU1wTCxtQkFBbUIsR0FBRyxDQUFDLEtBQUtELG9CQUFOLEdBQ3hCOEcsYUFEd0IsR0FFeEIsS0FBSzlHLG9CQUZUO01BR0EsS0FBS0Usd0JBQUwsR0FBZ0MsQ0FDOUIsb0JBQ0VELG1CQURGLEVBRUU4SCxzQkFBVUUsT0FGWixFQUdFLEtBQUt6SyxrQkFIUCxFQUlFLElBSkYsQ0FEOEIsRUFPOUIsb0JBQ0V5QyxtQkFERixFQUVFOEgsc0JBQVV1RCxRQUZaLEVBR0UsS0FBSzlOLGtCQUhQLEVBSUUsSUFKRixDQVA4QixFQWE5QixvQkFBTzZOLFdBQVAsRUFBb0J0RCxzQkFBVXdELE1BQTlCLEVBQXNDLEtBQUtDLFVBQTNDLEVBQXVELElBQXZELENBYjhCLENBQWhDO0lBZUQ7O0lBRUQsS0FBS0EsVUFBTCxHQXJGRixDQXNGRTtJQUNBO0VBQ0QsQ0F4RkQ7RUEwRkE7Ozs7O0VBR0ExSTtJQUNFLEtBQUsySCxNQUFMO0VBQ0QsQ0FGRDtFQUlBOzs7OztFQUdBM0g7SUFDRSxLQUFLMkgsTUFBTDtFQUNELENBRkQ7RUFJQTs7Ozs7RUFHQTNIO0lBQ0UsSUFBSSxLQUFLbkUsd0JBQVQsRUFBbUM7TUFDakMsMkJBQWMsS0FBS0Esd0JBQW5CO01BQ0EsS0FBS0Esd0JBQUwsR0FBZ0MsSUFBaEM7SUFDRDs7SUFDRCxJQUFJLEtBQUtDLHNCQUFULEVBQWlDO01BQy9CLDJCQUFjLEtBQUtBLHNCQUFuQjtNQUNBLEtBQUtBLHNCQUFMLEdBQThCLElBQTlCO0lBQ0Q7O0lBQ0QsSUFBTStDLElBQUksR0FBRyxLQUFLNEQsT0FBTCxFQUFiOztJQUNBLElBQUk1RCxJQUFKLEVBQVU7TUFDUixLQUFLOEosbUJBQUw7TUFFQSxLQUFLOU0sd0JBQUwsR0FBZ0Msb0JBQzlCZ0QsSUFEOEIsRUFFOUIrSiw0QkFBZ0JDLGNBRmMsRUFHOUIsS0FBS0MsMEJBSHlCLEVBSTlCLElBSjhCLENBQWhDO01BTUEsS0FBS2hOLHNCQUFMLEdBQThCLG9CQUM1QitDLElBRDRCLEVBRTVCb0csc0JBQVU4RCxNQUZrQixFQUc1QixLQUFLRCwwQkFIdUIsRUFJNUIsSUFKNEIsQ0FBOUI7TUFPQWpLLElBQUksQ0FBQzZJLGtCQUFMLENBQXdCLENBQXhCO0lBQ0Q7O0lBQ0QsS0FBS0MsTUFBTDtFQUNELENBN0JEO0VBK0JBOzs7OztFQUdBM0g7SUFDRSxJQUFJLEtBQUtqRSwrQkFBVCxFQUEwQztNQUN4QyxLQUFLQSwrQkFBTCxDQUFxQ3pDLE9BQXJDLENBQTZDMFAscUJBQTdDO01BQ0EsS0FBS2pOLCtCQUFMLEdBQXVDLElBQXZDO0lBQ0Q7O0lBQ0QsSUFBTXlGLFVBQVUsR0FBRyxLQUFLbkIsYUFBTCxFQUFuQjs7SUFDQSxJQUFJbUIsVUFBSixFQUFnQjtNQUNkLEtBQUt5SCxlQUFMLENBQXFCLElBQUlDLGlCQUFKLENBQWUsVUFBZixFQUEyQjFILFVBQTNCLENBQXJCO01BQ0EsS0FBS3pGLCtCQUFMLEdBQXVDLENBQ3JDLG9CQUFPeUYsVUFBUCxFQUFtQm9ILDRCQUFnQkMsY0FBbkMsRUFBbUQsS0FBS2xCLE1BQXhELEVBQWdFLElBQWhFLENBRHFDLEVBRXJDLG9CQUFPbkcsVUFBUCxFQUFtQnlELHNCQUFVOEQsTUFBN0IsRUFBcUMsS0FBS3BCLE1BQTFDLEVBQWtELElBQWxELENBRnFDLEVBR3JDLG9CQUFPbkcsVUFBUCxFQUFtQixVQUFuQixFQUErQixLQUFLeUgsZUFBcEMsRUFBcUQsSUFBckQsQ0FIcUMsRUFJckMsb0JBQU96SCxVQUFQLEVBQW1CLGFBQW5CLEVBQWtDLEtBQUsySCxrQkFBdkMsRUFBMkQsSUFBM0QsQ0FKcUMsQ0FBdkM7SUFNRDs7SUFDRCxLQUFLeEIsTUFBTDtFQUNELENBaEJEO0VBa0JBOzs7OztFQUdBM0g7SUFDRSxPQUFPLENBQUMsQ0FBQyxLQUFLckUsV0FBZDtFQUNELENBRkQ7RUFJQTs7Ozs7O0VBSUFxRTtJQUNFLElBQUksS0FBSzdFLGtCQUFULEVBQTZCO01BQzNCNk0sb0JBQW9CLENBQUMsS0FBSzdNLGtCQUFOLENBQXBCO0lBQ0Q7O0lBQ0QsS0FBS0MsZUFBTDtFQUNELENBTEQ7RUFPQTs7Ozs7RUFHQTRFO0lBQ0UsSUFBTW9KLFdBQVcsR0FBRyxLQUFLL0ksYUFBTCxHQUFxQitDLG1CQUFyQixFQUFwQjs7SUFDQSxLQUFLLElBQUl6SixDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUd3UCxXQUFXLENBQUN2UCxNQUFqQyxFQUF5Q0YsQ0FBQyxHQUFHQyxFQUE3QyxFQUFpRCxFQUFFRCxDQUFuRCxFQUFzRDtNQUNwRCxJQUFNVixLQUFLLEdBQUdtUSxXQUFXLENBQUN6UCxDQUFELENBQVgsQ0FBZVYsS0FBN0I7O01BQ0EsSUFBSUEsS0FBSyxDQUFDb1EsV0FBTixFQUFKLEVBQXlCO1FBQ3ZCcFEsS0FBSyxDQUFDdUssV0FBTixHQUFvQjhGLGtCQUFwQjtNQUNEO0lBQ0Y7RUFDRixDQVJEO0VBVUE7Ozs7OztFQUlBdEo7SUFDRSxJQUFJLEtBQUtyQyxTQUFMLElBQWtCLEtBQUt4QyxrQkFBTCxLQUE0QkwsU0FBbEQsRUFBNkQ7TUFDM0QsS0FBS0ssa0JBQUwsR0FBMEJvTyxxQkFBcUIsQ0FBQyxLQUFLbk8sZUFBTixDQUEvQztJQUNEO0VBQ0YsQ0FKRDtFQU1BOzs7Ozs7Ozs7RUFPQTRFLGlEQUFjRixPQUFkLEVBQXFCO0lBQ25CLE9BQU8sS0FBS0ksV0FBTCxHQUFtQnNKLE1BQW5CLENBQTBCMUosT0FBMUIsQ0FBUDtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7O0VBT0FFLHFEQUFrQkQsV0FBbEIsRUFBNkI7SUFDM0IsT0FBTyxLQUFLSyxlQUFMLEdBQXVCb0osTUFBdkIsQ0FBOEJ6SixXQUE5QixDQUFQO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7Ozs7RUFPQUMsK0NBQVkvRyxLQUFaLEVBQWlCO0lBQ2YsSUFBTVEsTUFBTSxHQUFHLEtBQUs0RyxhQUFMLEdBQXFCaEgsU0FBckIsRUFBZjtJQUNBLE9BQU9JLE1BQU0sQ0FBQytQLE1BQVAsQ0FBY3ZRLEtBQWQsQ0FBUDtFQUNELENBSEQ7RUFLQTs7Ozs7O0VBSUErRyxzREFBbUJYLEtBQW5CLEVBQXdCO0lBQ3RCckcsc0JBQXNCLENBQUNxRyxLQUFLLENBQUNwRyxLQUFQLENBQXRCO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7Ozs7RUFPQStHLGlEQUFjTixPQUFkLEVBQXFCO0lBQ25CLE9BQU8sS0FBS1ksV0FBTCxHQUFtQmtKLE1BQW5CLENBQTBCOUosT0FBMUIsQ0FBUDtFQUNELENBRkQ7RUFJQTs7Ozs7O0VBSUFNLGdEQUFhMkcsSUFBYixFQUFpQjtJQUFqQjs7SUFDRSxJQUFNOEMsSUFBSSxHQUFHLEtBQUtDLE9BQUwsRUFBYjtJQUNBLElBQU03SyxJQUFJLEdBQUcsS0FBSzRELE9BQUwsRUFBYjtJQUNBLElBQU1rSCxrQkFBa0IsR0FBRyxLQUFLaE8sV0FBaEM7SUFDQTs7SUFDQSxJQUFJZ0gsVUFBVSxHQUFHLElBQWpCOztJQUNBLElBQUk4RyxJQUFJLEtBQUszTyxTQUFULElBQXNCLG1CQUFRMk8sSUFBUixDQUF0QixJQUF1QzVLLElBQXZDLElBQStDQSxJQUFJLENBQUMrSyxLQUFMLEVBQW5ELEVBQWlFO01BQy9ELElBQU10RCxTQUFTLEdBQUd6SCxJQUFJLENBQUNnTCxRQUFMLENBQ2hCLEtBQUtsTyxXQUFMLEdBQW1CLEtBQUtBLFdBQUwsQ0FBaUIySyxTQUFwQyxHQUFnRHhMLFNBRGhDLENBQWxCO01BR0EsSUFBTWdQLFNBQVMsR0FBR2pMLElBQUksQ0FBQ2tMLFFBQUwsRUFBbEI7TUFDQXBILFVBQVUsR0FBRztRQUNYb0UsT0FBTyxFQUFFLEtBREU7UUFFWGhELDBCQUEwQixFQUFFLEtBQUt2SSwyQkFGdEI7UUFHWHdPLGFBQWEsRUFBRSxJQUhKO1FBSVhDLE1BQU0sRUFBRSwrQkFDTkgsU0FBUyxDQUFDSSxNQURKLEVBRU5KLFNBQVMsQ0FBQ0ssVUFGSixFQUdOTCxTQUFTLENBQUNNLFFBSEosRUFJTlgsSUFKTSxDQUpHO1FBVVhZLEtBQUssRUFBRSxLQUFLM08sV0FBTCxFQVZJO1FBV1g0TyxVQUFVLEVBQUUsQ0FYRDtRQVlYbkgsZ0JBQWdCLEVBQUUsS0FBSzlDLGFBQUwsR0FBcUIrQyxtQkFBckIsRUFaUDtRQWFYcEksVUFBVSxFQUFFLEtBQUtELFdBYk47UUFjWDZILDBCQUEwQixFQUFFLEtBQUtuSCwyQkFkdEI7UUFlWCtMLG1CQUFtQixFQUFFLEVBZlY7UUFnQlhpQyxJQUFJLEVBQUVBLElBaEJLO1FBaUJYeEQsU0FBUyxFQUFFLEtBQUtwSSxVQWpCTDtRQWtCWDhJLElBQUksRUFBRUEsSUFsQks7UUFtQlg0RCxTQUFTLEVBQUUsRUFuQkE7UUFvQlhULFNBQVMsRUFBRUEsU0FwQkE7UUFxQlh4RCxTQUFTLEVBQUVBLFNBckJBO1FBc0JYa0UsV0FBVyxFQUFFLEVBdEJGO1FBdUJYQyxLQUFLLEVBQUUsa0JBQU8sSUFBUCxDQXZCSTtRQXdCWEMsYUFBYSxFQUFFO01BeEJKLENBQWI7O01BMEJBLElBQUlaLFNBQVMsQ0FBQ2EsVUFBVixJQUF3QmIsU0FBUyxDQUFDYyxjQUF0QyxFQUFzRDtRQUNwRCxJQUFNUixRQUFRLEdBQUdTLEtBQUssQ0FBQ2YsU0FBUyxDQUFDZ0IsWUFBWCxDQUFMLEdBQ2JoQixTQUFTLENBQUNNLFFBREcsR0FFYk4sU0FBUyxDQUFDZ0IsWUFGZDtRQUlBbkksVUFBVSxDQUFDb0ksVUFBWCxHQUF3QiwrQkFDdEJqQixTQUFTLENBQUNhLFVBRFksRUFFdEJiLFNBQVMsQ0FBQ2MsY0FGWSxFQUd0QlIsUUFIc0IsRUFJdEJYLElBSnNCLENBQXhCO01BTUQ7SUFDRjs7SUFFRCxLQUFLOU4sV0FBTCxHQUFtQmdILFVBQW5CO0lBQ0E7O0lBQ0UsS0FBS2hGLFNBRDRDLENBRWpEcU4sV0FGaUQsQ0FFckNySSxVQUZxQzs7SUFJbkQsSUFBSUEsVUFBSixFQUFnQjtNQUNkLElBQUlBLFVBQVUsQ0FBQ29FLE9BQWYsRUFBd0I7UUFDdEIsS0FBS1ksTUFBTDtNQUNEOztNQUNEc0QsS0FBSyxDQUFDQyxTQUFOLENBQWdCL0ssSUFBaEIsQ0FBcUJnTCxLQUFyQixDQUNFLEtBQUt2TixvQkFEUCxFQUVFK0UsVUFBVSxDQUFDNkUsbUJBRmI7O01BS0EsSUFBSW1DLGtCQUFKLEVBQXdCO1FBQ3RCLElBQU15QixTQUFTLEdBQ2IsQ0FBQyxLQUFLeFAsZUFBTixJQUNDLENBQUMscUJBQVEsS0FBS0EsZUFBYixDQUFELElBQ0MsQ0FBQyxvQkFBTytHLFVBQVUsQ0FBQ3NILE1BQWxCLEVBQTBCLEtBQUtyTyxlQUEvQixDQUhMOztRQUlBLElBQUl3UCxTQUFKLEVBQWU7VUFDYixLQUFLMUYsYUFBTCxDQUNFLElBQUkwQixvQkFBSixDQUFhQyx5QkFBYWdFLFNBQTFCLEVBQXFDLElBQXJDLEVBQTJDMUIsa0JBQTNDLENBREY7VUFHQSxLQUFLL04sZUFBTCxHQUF1QixpQ0FBb0IsS0FBS0EsZUFBekIsQ0FBdkI7UUFDRDtNQUNGOztNQUVELElBQU0wUCxJQUFJLEdBQ1IsS0FBSzFQLGVBQUwsSUFDQSxDQUFDK0csVUFBVSxDQUFDMkQsU0FBWCxDQUFxQkMscUJBQVNDLFNBQTlCLENBREQsSUFFQSxDQUFDN0QsVUFBVSxDQUFDMkQsU0FBWCxDQUFxQkMscUJBQVNFLFdBQTlCLENBRkQsSUFHQSxDQUFDLG9CQUFPOUQsVUFBVSxDQUFDc0gsTUFBbEIsRUFBMEIsS0FBS3JPLGVBQS9CLENBSkg7O01BTUEsSUFBSTBQLElBQUosRUFBVTtRQUNSLEtBQUs1RixhQUFMLENBQ0UsSUFBSTBCLG9CQUFKLENBQWFDLHlCQUFha0UsT0FBMUIsRUFBbUMsSUFBbkMsRUFBeUM1SSxVQUF6QyxDQURGO1FBR0EsbUJBQU1BLFVBQVUsQ0FBQ3NILE1BQWpCLEVBQXlCLEtBQUtyTyxlQUE5QjtNQUNEO0lBQ0Y7O0lBRUQsS0FBSzhKLGFBQUwsQ0FBbUIsSUFBSTBCLG9CQUFKLENBQWFDLHlCQUFhbUUsVUFBMUIsRUFBc0MsSUFBdEMsRUFBNEM3SSxVQUE1QyxDQUFuQjtJQUVBLEtBQUtwSSxlQUFMLEdBQ0UsS0FBS3lNLFdBQUwsQ0FBaUJLLHlCQUFhRSxTQUE5QixLQUNBLEtBQUtQLFdBQUwsQ0FBaUJLLHlCQUFhQyxPQUE5QixDQURBLElBRUEsS0FBS04sV0FBTCxDQUFpQkMsdUJBQWdCQyxjQUFqQyxDQUZBLEdBR0ksQ0FBQyxLQUFLckosVUFBTCxDQUFnQitJLGVBQWhCLEVBQUQsSUFDQSxDQUFDLEtBQUsvSSxVQUFMLENBQWdCNE4sUUFBaEIsRUFERCxJQUVBLENBQUMsS0FBS0Msb0JBQUwsRUFMTCxHQU1JNVEsU0FQTjs7SUFTQSxJQUFJLENBQUMsS0FBS0ksd0JBQVYsRUFBb0M7TUFDbEMsS0FBS0Esd0JBQUwsR0FBZ0N5USxVQUFVLENBQUM7UUFDekMxUixLQUFJLENBQUNpQix3QkFBTCxHQUFnQ0osU0FBaEM7O1FBQ0FiLEtBQUksQ0FBQzJSLGdCQUFMO01BQ0QsQ0FIeUMsRUFHdkMsQ0FIdUMsQ0FBMUM7SUFJRDtFQUNGLENBN0dEO0VBK0dBOzs7Ozs7OztFQU1BNUwsaURBQWN3QixVQUFkLEVBQXdCO0lBQ3RCLElBQU1xSyxhQUFhLEdBQUcsS0FBS3hMLGFBQUwsRUFBdEI7O0lBQ0EsSUFBSXdMLGFBQUosRUFBbUI7TUFDakIsS0FBSzFDLGtCQUFMLENBQXdCLElBQUlELGlCQUFKLENBQWUsYUFBZixFQUE4QjJDLGFBQTlCLENBQXhCO0lBQ0Q7O0lBQ0QsS0FBS0MsR0FBTCxDQUFTNU4sd0JBQVlDLFVBQXJCLEVBQWlDcUQsVUFBakM7RUFDRCxDQU5EO0VBUUE7Ozs7Ozs7O0VBTUF4QiwyQ0FBUXlKLElBQVIsRUFBWTtJQUNWLEtBQUtxQyxHQUFMLENBQVM1Tix3QkFBWUssSUFBckIsRUFBMkJrTCxJQUEzQjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7O0VBT0F6Siw2Q0FBVXNDLE1BQVYsRUFBZ0I7SUFDZCxLQUFLd0osR0FBTCxDQUFTNU4sd0JBQVlPLE1BQXJCLEVBQTZCNkQsTUFBN0I7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7Ozs7O0VBU0F0QywyQ0FBUW5CLElBQVIsRUFBWTtJQUNWLElBQUksQ0FBQ0EsSUFBRCxJQUFTQSxJQUFJLFlBQVlDLGdCQUE3QixFQUFtQztNQUNqQyxLQUFLZ04sR0FBTCxDQUFTNU4sd0JBQVlHLElBQXJCLEVBQTJCUSxJQUEzQjtNQUNBO0lBQ0Q7O0lBQ0QsS0FBS2lOLEdBQUwsQ0FBUzVOLHdCQUFZRyxJQUFyQixFQUEyQixJQUFJUyxnQkFBSixFQUEzQjtJQUVBLElBQU10RixHQUFHLEdBQUcsSUFBWjtJQUNBcUYsSUFBSSxDQUFDRSxJQUFMLENBQVUsVUFBVUMsV0FBVixFQUFxQjtNQUM3QnhGLEdBQUcsQ0FBQ3lGLE9BQUosQ0FBWSxJQUFJSCxnQkFBSixDQUFTRSxXQUFULENBQVo7SUFDRCxDQUZEO0VBR0QsQ0FYRDtFQWFBOzs7Ozs7O0VBS0FnQjtJQUNFLElBQU1nRSxhQUFhLEdBQUcsS0FBS0MsZ0JBQUwsRUFBdEI7SUFFQSxJQUFJd0YsSUFBSSxHQUFHM08sU0FBWDs7SUFDQSxJQUFJa0osYUFBSixFQUFtQjtNQUNqQixJQUFNK0gsYUFBYSxHQUFHQyxnQkFBZ0IsQ0FBQ2hJLGFBQUQsQ0FBdEM7TUFDQSxJQUFNeEgsS0FBSyxHQUNUd0gsYUFBYSxDQUFDaUksV0FBZCxHQUNBQyxVQUFVLENBQUNILGFBQWEsQ0FBQyxpQkFBRCxDQUFkLENBRFYsR0FFQUcsVUFBVSxDQUFDSCxhQUFhLENBQUMsYUFBRCxDQUFkLENBRlYsR0FHQUcsVUFBVSxDQUFDSCxhQUFhLENBQUMsY0FBRCxDQUFkLENBSFYsR0FJQUcsVUFBVSxDQUFDSCxhQUFhLENBQUMsa0JBQUQsQ0FBZCxDQUxaO01BTUEsSUFBTXRQLE1BQU0sR0FDVnVILGFBQWEsQ0FBQ21JLFlBQWQsR0FDQUQsVUFBVSxDQUFDSCxhQUFhLENBQUMsZ0JBQUQsQ0FBZCxDQURWLEdBRUFHLFVBQVUsQ0FBQ0gsYUFBYSxDQUFDLFlBQUQsQ0FBZCxDQUZWLEdBR0FHLFVBQVUsQ0FBQ0gsYUFBYSxDQUFDLGVBQUQsQ0FBZCxDQUhWLEdBSUFHLFVBQVUsQ0FBQ0gsYUFBYSxDQUFDLG1CQUFELENBQWQsQ0FMWjs7TUFNQSxJQUFJLENBQUNsQixLQUFLLENBQUNyTyxLQUFELENBQU4sSUFBaUIsQ0FBQ3FPLEtBQUssQ0FBQ3BPLE1BQUQsQ0FBM0IsRUFBcUM7UUFDbkNnTixJQUFJLEdBQUcsQ0FBQ2pOLEtBQUQsRUFBUUMsTUFBUixDQUFQOztRQUNBLElBQ0UsQ0FBQyxtQkFBUWdOLElBQVIsQ0FBRCxJQUNBLENBQUMsRUFDQ3pGLGFBQWEsQ0FBQ2lJLFdBQWQsSUFDQWpJLGFBQWEsQ0FBQ21JLFlBRGQsSUFFQW5JLGFBQWEsQ0FBQ29JLGNBQWQsR0FBK0J2UyxNQUhoQyxDQUZILEVBT0U7VUFDQTtVQUNBd1MsT0FBTyxDQUFDQyxJQUFSLENBQ0UsbUVBREY7UUFHRDtNQUNGO0lBQ0Y7O0lBRUQsS0FBS0MsT0FBTCxDQUFhOUMsSUFBYjtJQUNBLEtBQUtkLG1CQUFMO0VBQ0QsQ0F0Q0Q7RUF3Q0E7Ozs7OztFQUlBM0k7SUFDRSxJQUFNbkIsSUFBSSxHQUFHLEtBQUs0RCxPQUFMLEVBQWI7O0lBQ0EsSUFBSTVELElBQUosRUFBVTtNQUNSLElBQUk0SyxJQUFJLEdBQUczTyxTQUFYO01BQ0EsSUFBTWlSLGFBQWEsR0FBR0MsZ0JBQWdCLENBQUMsS0FBS2hRLFNBQU4sQ0FBdEM7O01BQ0EsSUFBSStQLGFBQWEsQ0FBQ3ZQLEtBQWQsSUFBdUJ1UCxhQUFhLENBQUN0UCxNQUF6QyxFQUFpRDtRQUMvQ2dOLElBQUksR0FBRyxDQUNMK0MsUUFBUSxDQUFDVCxhQUFhLENBQUN2UCxLQUFmLEVBQXNCLEVBQXRCLENBREgsRUFFTGdRLFFBQVEsQ0FBQ1QsYUFBYSxDQUFDdFAsTUFBZixFQUF1QixFQUF2QixDQUZILENBQVA7TUFJRDs7TUFDRG9DLElBQUksQ0FBQzROLGVBQUwsQ0FBcUJoRCxJQUFyQjtJQUNEO0VBQ0YsQ0FiRDs7RUFjRjtBQUFDLENBbmdERCxDQUEyQmlELGtCQUEzQjtBQXFnREE7Ozs7OztBQUlBLFNBQVNwUyxxQkFBVCxDQUErQlAsT0FBL0IsRUFBc0M7RUFDcEM7OztFQUdBLElBQUlvRCxtQkFBbUIsR0FBRyxJQUExQjs7RUFDQSxJQUFJcEQsT0FBTyxDQUFDb0QsbUJBQVIsS0FBZ0NyQyxTQUFwQyxFQUErQztJQUM3Q3FDLG1CQUFtQixHQUNqQixPQUFPcEQsT0FBTyxDQUFDb0QsbUJBQWYsS0FBdUMsUUFBdkMsR0FDSWxCLFFBQVEsQ0FBQ3VHLGNBQVQsQ0FBd0J6SSxPQUFPLENBQUNvRCxtQkFBaEMsQ0FESixHQUVJcEQsT0FBTyxDQUFDb0QsbUJBSGQ7RUFJRDtFQUVEOzs7OztFQUdBLElBQU15QixNQUFNLEdBQUcsRUFBZjtFQUVBLElBQU00QyxVQUFVLEdBQ2R6SCxPQUFPLENBQUNOLE1BQVIsSUFDQTtFQUFRO0VBQWtCTSxPQUFPLENBQUNOLE1BQVQsQ0FBaUJKLFNBQTFDLEtBQXlELFVBRHpEO0VBRUk7RUFBMkJVLE9BQU8sQ0FBQ04sTUFGdkMsR0FHSSxJQUFJTCxpQkFBSixDQUFlO0lBQUNLLE1BQU07SUFBRTtJQUEyQk0sT0FBTyxDQUFDTjtFQUE1QyxDQUFmLENBSk47RUFLQW1GLE1BQU0sQ0FBQ1Ysd0JBQVlDLFVBQWIsQ0FBTixHQUFpQ3FELFVBQWpDO0VBRUE1QyxNQUFNLENBQUNWLHdCQUFZTyxNQUFiLENBQU4sR0FBNkIxRSxPQUFPLENBQUN1SSxNQUFyQztFQUVBMUQsTUFBTSxDQUFDVix3QkFBWUcsSUFBYixDQUFOLEdBQ0V0RSxPQUFPLENBQUM4RSxJQUFSLFlBQXdCQyxnQkFBeEIsR0FBK0IvRSxPQUFPLENBQUM4RSxJQUF2QyxHQUE4QyxJQUFJQyxnQkFBSixFQURoRDtFQUdBLElBQUl6QixRQUFKOztFQUNBLElBQUl0RCxPQUFPLENBQUNzRCxRQUFSLEtBQXFCdkMsU0FBekIsRUFBb0M7SUFDbEMsSUFBSW1RLEtBQUssQ0FBQzBCLE9BQU4sQ0FBYzVTLE9BQU8sQ0FBQ3NELFFBQXRCLENBQUosRUFBcUM7TUFDbkNBLFFBQVEsR0FBRyxJQUFJQyxzQkFBSixDQUFldkQsT0FBTyxDQUFDc0QsUUFBUixDQUFpQndGLEtBQWpCLEVBQWYsQ0FBWDtJQUNELENBRkQsTUFFTztNQUNMLHFCQUNFO01BQVE7TUFBa0I5SSxPQUFPLENBQUNzRCxRQUFULENBQW1CM0QsUUFBNUMsS0FBMEQsVUFENUQsRUFFRSxFQUZGLEVBREssQ0FJRjs7TUFDSDJELFFBQVE7TUFBRztNQUEyQnRELE9BQU8sQ0FBQ3NELFFBQTlDO0lBQ0Q7RUFDRjs7RUFFRCxJQUFJRSxZQUFKOztFQUNBLElBQUl4RCxPQUFPLENBQUN3RCxZQUFSLEtBQXlCekMsU0FBN0IsRUFBd0M7SUFDdEMsSUFBSW1RLEtBQUssQ0FBQzBCLE9BQU4sQ0FBYzVTLE9BQU8sQ0FBQ3dELFlBQXRCLENBQUosRUFBeUM7TUFDdkNBLFlBQVksR0FBRyxJQUFJRCxzQkFBSixDQUFldkQsT0FBTyxDQUFDd0QsWUFBUixDQUFxQnNGLEtBQXJCLEVBQWYsQ0FBZjtJQUNELENBRkQsTUFFTztNQUNMLHFCQUNFO01BQVE7TUFBa0I5SSxPQUFPLENBQUN3RCxZQUFULENBQXVCN0QsUUFBaEQsS0FDRSxVQUZKLEVBR0UsRUFIRixFQURLLENBS0Y7O01BQ0g2RCxZQUFZO01BQUc7TUFBMkJ4RCxPQUFPLENBQUN3RCxZQUFsRDtJQUNEO0VBQ0Y7O0VBRUQsSUFBSUUsUUFBSjs7RUFDQSxJQUFJMUQsT0FBTyxDQUFDMEQsUUFBUixLQUFxQjNDLFNBQXpCLEVBQW9DO0lBQ2xDLElBQUltUSxLQUFLLENBQUMwQixPQUFOLENBQWM1UyxPQUFPLENBQUMwRCxRQUF0QixDQUFKLEVBQXFDO01BQ25DQSxRQUFRLEdBQUcsSUFBSUgsc0JBQUosQ0FBZXZELE9BQU8sQ0FBQzBELFFBQVIsQ0FBaUJvRixLQUFqQixFQUFmLENBQVg7SUFDRCxDQUZELE1BRU87TUFDTCxxQkFDRTtNQUFRO01BQWtCOUksT0FBTyxDQUFDMEQsUUFBVCxDQUFtQi9ELFFBQTVDLEtBQTBELFVBRDVELEVBRUUsRUFGRixFQURLLENBSUY7O01BQ0grRCxRQUFRLEdBQUcxRCxPQUFPLENBQUMwRCxRQUFuQjtJQUNEO0VBQ0YsQ0FWRCxNQVVPO0lBQ0xBLFFBQVEsR0FBRyxJQUFJSCxzQkFBSixFQUFYO0VBQ0Q7O0VBRUQsT0FBTztJQUNMRCxRQUFRLEVBQUVBLFFBREw7SUFFTEUsWUFBWSxFQUFFQSxZQUZUO0lBR0xKLG1CQUFtQixFQUFFQSxtQkFIaEI7SUFJTE0sUUFBUSxFQUFFQSxRQUpMO0lBS0xtQixNQUFNLEVBQUVBO0VBTEgsQ0FBUDtBQU9EOztlQUNjb0IsWSIsIm5hbWVzIjpbInJlbW92ZUxheWVyTWFwUHJvcGVydHkiLCJsYXllciIsIkxheWVyIiwic2V0TWFwSW50ZXJuYWwiLCJMYXllckdyb3VwIiwiZ2V0TGF5ZXJzIiwiZm9yRWFjaCIsInNldExheWVyTWFwUHJvcGVydHkiLCJtYXAiLCJsYXllcnMiLCJnZXRBcnJheSIsImkiLCJpaSIsImxlbmd0aCIsIl9fZXh0ZW5kcyIsIm9wdGlvbnMiLCJfc3VwZXIiLCJfdGhpcyIsIm9uIiwib25jZSIsInVuIiwib3B0aW9uc0ludGVybmFsIiwiY3JlYXRlT3B0aW9uc0ludGVybmFsIiwicmVuZGVyQ29tcGxldGVfIiwibG9hZGVkXyIsImJvdW5kSGFuZGxlQnJvd3NlckV2ZW50XyIsImhhbmRsZUJyb3dzZXJFdmVudCIsImJpbmQiLCJtYXhUaWxlc0xvYWRpbmdfIiwibWF4VGlsZXNMb2FkaW5nIiwidW5kZWZpbmVkIiwicGl4ZWxSYXRpb18iLCJwaXhlbFJhdGlvIiwiREVWSUNFX1BJWEVMX1JBVElPIiwicG9zdFJlbmRlclRpbWVvdXRIYW5kbGVfIiwiYW5pbWF0aW9uRGVsYXlLZXlfIiwiYW5pbWF0aW9uRGVsYXlfIiwicmVuZGVyRnJhbWVfIiwiRGF0ZSIsIm5vdyIsImNvb3JkaW5hdGVUb1BpeGVsVHJhbnNmb3JtXyIsInBpeGVsVG9Db29yZGluYXRlVHJhbnNmb3JtXyIsImZyYW1lSW5kZXhfIiwiZnJhbWVTdGF0ZV8iLCJwcmV2aW91c0V4dGVudF8iLCJ2aWV3UHJvcGVydHlMaXN0ZW5lcktleV8iLCJ2aWV3Q2hhbmdlTGlzdGVuZXJLZXlfIiwibGF5ZXJHcm91cFByb3BlcnR5TGlzdGVuZXJLZXlzXyIsInZpZXdwb3J0XyIsImRvY3VtZW50IiwiY3JlYXRlRWxlbWVudCIsImNsYXNzTmFtZSIsIndpbmRvdyIsInN0eWxlIiwicG9zaXRpb24iLCJvdmVyZmxvdyIsIndpZHRoIiwiaGVpZ2h0Iiwib3ZlcmxheUNvbnRhaW5lcl8iLCJ6SW5kZXgiLCJwb2ludGVyRXZlbnRzIiwiYXBwZW5kQ2hpbGQiLCJvdmVybGF5Q29udGFpbmVyU3RvcEV2ZW50XyIsIm1hcEJyb3dzZXJFdmVudEhhbmRsZXJfIiwibW92ZVRvbGVyYW5jZV8iLCJtb3ZlVG9sZXJhbmNlIiwia2V5Ym9hcmRFdmVudFRhcmdldF8iLCJrZXlib2FyZEV2ZW50VGFyZ2V0IiwidGFyZ2V0Q2hhbmdlSGFuZGxlcktleXNfIiwiY29udHJvbHMiLCJDb2xsZWN0aW9uIiwiaW50ZXJhY3Rpb25zIiwib3ZlcmxheXNfIiwib3ZlcmxheXMiLCJvdmVybGF5SWRJbmRleF8iLCJyZW5kZXJlcl8iLCJwb3N0UmVuZGVyRnVuY3Rpb25zXyIsInRpbGVRdWV1ZV8iLCJUaWxlUXVldWUiLCJnZXRUaWxlUHJpb3JpdHkiLCJoYW5kbGVUaWxlQ2hhbmdlXyIsImFkZENoYW5nZUxpc3RlbmVyIiwiTWFwUHJvcGVydHkiLCJMQVlFUkdST1VQIiwiaGFuZGxlTGF5ZXJHcm91cENoYW5nZWRfIiwiVklFVyIsImhhbmRsZVZpZXdDaGFuZ2VkXyIsIlNJWkUiLCJoYW5kbGVTaXplQ2hhbmdlZF8iLCJUQVJHRVQiLCJoYW5kbGVUYXJnZXRDaGFuZ2VkXyIsInNldFByb3BlcnRpZXMiLCJ2YWx1ZXMiLCJ2aWV3IiwiVmlldyIsInRoZW4iLCJ2aWV3T3B0aW9ucyIsInNldFZpZXciLCJhZGRFdmVudExpc3RlbmVyIiwiQ29sbGVjdGlvbkV2ZW50VHlwZSIsIkFERCIsImV2ZW50IiwiZWxlbWVudCIsInNldE1hcCIsIlJFTU9WRSIsImFkZE92ZXJsYXlJbnRlcm5hbF8iLCJvdmVybGF5IiwiaWQiLCJnZXRJZCIsInRvU3RyaW5nIiwiY29udHJvbCIsImludGVyYWN0aW9uIiwiUGx1Z2dhYmxlTWFwIiwiRXJyb3IiLCJnZXRDb250cm9scyIsInB1c2giLCJnZXRJbnRlcmFjdGlvbnMiLCJnZXRMYXllckdyb3VwIiwiZ2V0T3ZlcmxheXMiLCJzZXRUYXJnZXQiLCJkaXNwb3NlSW50ZXJuYWwiLCJjYWxsIiwicGl4ZWwiLCJjYWxsYmFjayIsIm9wdF9vcHRpb25zIiwiY29vcmRpbmF0ZSIsImdldENvb3JkaW5hdGVGcm9tUGl4ZWxJbnRlcm5hbCIsImhpdFRvbGVyYW5jZSIsImxheWVyRmlsdGVyIiwiVFJVRSIsImNoZWNrV3JhcHBlZCIsImZvckVhY2hGZWF0dXJlQXRDb29yZGluYXRlIiwiZmVhdHVyZXMiLCJmb3JFYWNoRmVhdHVyZUF0UGl4ZWwiLCJmZWF0dXJlIiwiYWRkTGF5ZXJzRnJvbSIsImxheWVyR3JvdXAiLCJmb3JFYWNoTGF5ZXJBdFBpeGVsIiwiaGFzRmVhdHVyZUF0Q29vcmRpbmF0ZSIsImdldENvb3JkaW5hdGVGcm9tUGl4ZWwiLCJnZXRFdmVudFBpeGVsIiwidmlld3BvcnRQb3NpdGlvbiIsImdldEJvdW5kaW5nQ2xpZW50UmVjdCIsImV2ZW50UG9zaXRpb24iLCJjaGFuZ2VkVG91Y2hlcyIsImNsaWVudFgiLCJsZWZ0IiwiY2xpZW50WSIsInRvcCIsImdldCIsInRhcmdldCIsImdldFRhcmdldCIsImdldEVsZW1lbnRCeUlkIiwiZ2V0VmlldyIsImdldFByb2plY3Rpb24iLCJmcmFtZVN0YXRlIiwicGl4ZWxUb0Nvb3JkaW5hdGVUcmFuc2Zvcm0iLCJzbGljZSIsImdyb3VwIiwic2V0TGF5ZXJzIiwiY29sbGVjdGlvbiIsImNsZWFyIiwiZXh0ZW5kIiwibGF5ZXJTdGF0ZXNBcnJheSIsImdldExheWVyU3RhdGVzQXJyYXkiLCJzdGF0ZSIsInZpc2libGUiLCJyZW5kZXJlciIsImdldFJlbmRlcmVyIiwicmVhZHkiLCJzb3VyY2UiLCJnZXRTb3VyY2UiLCJsb2FkaW5nIiwidmlld0Nvb3JkaW5hdGUiLCJnZXRQaXhlbEZyb21Db29yZGluYXRlSW50ZXJuYWwiLCJjb29yZGluYXRlVG9QaXhlbFRyYW5zZm9ybSIsInRhcmdldEVsZW1lbnQiLCJnZXRUYXJnZXRFbGVtZW50Iiwib3duZXJEb2N1bWVudCIsInRpbGUiLCJ0aWxlU291cmNlS2V5IiwidGlsZUNlbnRlciIsInRpbGVSZXNvbHV0aW9uIiwiYnJvd3NlckV2ZW50Iiwib3B0X3R5cGUiLCJ0eXBlIiwibWFwQnJvd3NlckV2ZW50IiwiTWFwQnJvd3NlckV2ZW50IiwiaGFuZGxlTWFwQnJvd3NlckV2ZW50Iiwib3JpZ2luYWxFdmVudCIsImV2ZW50VHlwZSIsIlBvaW50ZXJFdmVudFR5cGUiLCJQT0lOVEVSRE9XTiIsIkV2ZW50VHlwZSIsIldIRUVMIiwiS0VZRE9XTiIsImRvYyIsImdldE93bmVyRG9jdW1lbnQiLCJyb290Tm9kZSIsImdldFJvb3ROb2RlIiwiY29udGFpbnMiLCJkb2N1bWVudEVsZW1lbnQiLCJkaXNwYXRjaEV2ZW50IiwiaW50ZXJhY3Rpb25zQXJyYXkiLCJnZXRNYXAiLCJnZXRBY3RpdmUiLCJjb250IiwiaGFuZGxlRXZlbnQiLCJwcm9wYWdhdGlvblN0b3BwZWQiLCJ0aWxlUXVldWUiLCJpc0VtcHR5IiwibWF4VG90YWxMb2FkaW5nIiwibWF4TmV3TG9hZHMiLCJoaW50cyIsInZpZXdIaW50cyIsIlZpZXdIaW50IiwiQU5JTUFUSU5HIiwiSU5URVJBQ1RJTkciLCJsb3dPbkZyYW1lQnVkZ2V0IiwidGltZSIsImdldFRpbGVzTG9hZGluZyIsInJlcHJpb3JpdGl6ZSIsImxvYWRNb3JlVGlsZXMiLCJhbmltYXRlIiwiaGFzTGlzdGVuZXIiLCJSZW5kZXJFdmVudFR5cGUiLCJSRU5ERVJDT01QTEVURSIsImRpc3BhdGNoUmVuZGVyRXZlbnQiLCJNYXBFdmVudCIsIk1hcEV2ZW50VHlwZSIsIkxPQURFTkQiLCJMT0FEU1RBUlQiLCJwb3N0UmVuZGVyRnVuY3Rpb25zIiwiZ2V0QW5pbWF0aW5nIiwicmVzb2x2ZUNvbnN0cmFpbnRzIiwicmVuZGVyIiwicmVtb3ZlRXZlbnRMaXN0ZW5lciIsIkNPTlRFWFRNRU5VIiwiZGlzcG9zZSIsImNsZWFyVGltZW91dCIsImNhbmNlbEFuaW1hdGlvbkZyYW1lIiwiY3JlYXRlUmVuZGVyZXIiLCJNYXBCcm93c2VyRXZlbnRIYW5kbGVyIiwia2V5IiwiTWFwQnJvd3NlckV2ZW50VHlwZSIsIlBBU1NJVkVfRVZFTlRfTElTVEVORVJTIiwicGFzc2l2ZSIsImRlZmF1bHRWaWV3IiwiS0VZUFJFU1MiLCJSRVNJWkUiLCJ1cGRhdGVTaXplIiwidXBkYXRlVmlld3BvcnRTaXplXyIsIk9iamVjdEV2ZW50VHlwZSIsIlBST1BFUlRZQ0hBTkdFIiwiaGFuZGxlVmlld1Byb3BlcnR5Q2hhbmdlZF8iLCJDSEFOR0UiLCJ1bmxpc3RlbkJ5S2V5IiwiaGFuZGxlTGF5ZXJBZGRfIiwiR3JvdXBFdmVudCIsImhhbmRsZUxheWVyUmVtb3ZlXyIsImxheWVyU3RhdGVzIiwiaGFzUmVuZGVyZXIiLCJoYW5kbGVGb250c0NoYW5nZWQiLCJyZXF1ZXN0QW5pbWF0aW9uRnJhbWUiLCJyZW1vdmUiLCJzaXplIiwiZ2V0U2l6ZSIsInByZXZpb3VzRnJhbWVTdGF0ZSIsImlzRGVmIiwiZ2V0SGludHMiLCJ2aWV3U3RhdGUiLCJnZXRTdGF0ZSIsImRlY2x1dHRlclRyZWUiLCJleHRlbnQiLCJjZW50ZXIiLCJyZXNvbHV0aW9uIiwicm90YXRpb24iLCJpbmRleCIsImxheWVySW5kZXgiLCJ1c2VkVGlsZXMiLCJ3YW50ZWRUaWxlcyIsIm1hcElkIiwicmVuZGVyVGFyZ2V0cyIsIm5leHRDZW50ZXIiLCJuZXh0UmVzb2x1dGlvbiIsImlzTmFOIiwibmV4dFJvdGF0aW9uIiwibmV4dEV4dGVudCIsInJlbmRlckZyYW1lIiwiQXJyYXkiLCJwcm90b3R5cGUiLCJhcHBseSIsIm1vdmVTdGFydCIsIk1PVkVTVEFSVCIsImlkbGUiLCJNT1ZFRU5EIiwiUE9TVFJFTkRFUiIsImdldENvdW50IiwiZ2V0TG9hZGluZ09yTm90UmVhZHkiLCJzZXRUaW1lb3V0IiwiaGFuZGxlUG9zdFJlbmRlciIsIm9sZExheWVyR3JvdXAiLCJzZXQiLCJjb21wdXRlZFN0eWxlIiwiZ2V0Q29tcHV0ZWRTdHlsZSIsIm9mZnNldFdpZHRoIiwicGFyc2VGbG9hdCIsIm9mZnNldEhlaWdodCIsImdldENsaWVudFJlY3RzIiwiY29uc29sZSIsIndhcm4iLCJzZXRTaXplIiwicGFyc2VJbnQiLCJzZXRWaWV3cG9ydFNpemUiLCJCYXNlT2JqZWN0IiwiaXNBcnJheSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvUGx1Z2dhYmxlTWFwLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19